(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7174"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7174"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("35ah2", function(module, exports) {

$parcel$export(module.exports, "VWValidator", () => $ab3cad173988158b$export$9353c916d8d127de);
class $ab3cad173988158b$export$9353c916d8d127de {
    constructor(){}
    static isNullOrUndefined(value) {
        // This method returns true if the given value is null or undefined, false otherwise.
        return value === null || value === undefined;
    }
    static allArgumentsExist(...obj) {
        return !$ab3cad173988158b$export$9353c916d8d127de.isNullOrUndefined(obj) && obj.every((value)=>!$ab3cad173988158b$export$9353c916d8d127de.isNullOrUndefined(value));
    }
    static allValuesExist(obj) {
        return !$ab3cad173988158b$export$9353c916d8d127de.isNullOrUndefined(obj) && $ab3cad173988158b$export$9353c916d8d127de.allArgumentsExist(...Array.from(obj));
    }
    static validateExistence(obj, errorMessage) {
        if ($ab3cad173988158b$export$9353c916d8d127de.allArgumentsExist(obj)) return obj;
        else throw new Error(errorMessage || "The object is null or undefined.");
    }
    static validateAllExistence(obj, errorMessage) {
        if ($ab3cad173988158b$export$9353c916d8d127de.allValuesExist(obj)) return obj;
        else throw new Error(errorMessage || "The object is null or undefined.");
    }
    static validateNumber(value, lowerBoundInclusive, upperBoundInclusive, errorMessage) {
        if (!$ab3cad173988158b$export$9353c916d8d127de.allArgumentsExist(value, lowerBoundInclusive, upperBoundInclusive)) throw new Error(errorMessage || "The value is null or undefined.");
        else if (typeof value !== "number" || typeof lowerBoundInclusive !== "number" || typeof upperBoundInclusive !== "number") throw new Error(errorMessage || "The value is not a number.");
        else if (value < lowerBoundInclusive || value > upperBoundInclusive) throw new Error(errorMessage || "The value is out of bounds.");
        else return value;
    }
}

});

parcelRegister("2kjdU", function(module, exports) {
module.exports = JSON.parse('{"GUI":{"IndexScript":{"ID":"index-script","ClassList":[]},"Stylesheets":{"ID":"stylesheet","ClassList":[],"StylesheetsDir":"/static/css/","Stylesheets":["index.css","light_theme.css","dark_theme.css"]},"Metadata":{"Title":"VacuumWorld","LockedInClassName":"locked-in","HighlightedClassName":"highlighted","SelectedClassName":"selected","DropZoneClassName":"drop-zone"},"Auth":{"AuthPath":"/auth/","AuthServerURL":"https://agent-auth.dicelab-rhul.org","OAuth20ExchangePath":"/auth/exchange/","OAuth20ClientName":"VacuumWorld","OAuth20RedirectURL":"https://vacuumworld.dicelab-rhul.org/post-auth/","OAuth20PostAuthRedirectURL":"https://vacuumworld.dicelab-rhul.org/"},"VWCookieConsentDiv":{"ID":"cookie-consent-div","ClassList":["cookie-consent-div"],"ClassListLight":["cookie-consent-div-light"],"ClassListDark":["cookie-consent-div-dark"],"WebAgentCookieConsentLabel":{"ID":"cookie-consent-label","ClassList":["cookie-consent-label"],"ClassListLight":["cookie-consent-label-light"],"ClassListDark":["cookie-consent-label-dark"],"Text":"This website uses first-party cookies to maintain user sessions, to authenticate users to the API server, and to mitigate CSRF attacks during authentication. By clicking on the button below, you consent to the use of such cookies. Your consent will be stored in a cookie as well. All cookies are marked as secure, httpOnly, and SameSite=Strict. As all cookies are essential for the functioning of this website, your only possible opt-out is to stop using this website right now."},"WebAgentCookieConsentButton":{"ID":"cookie-consent-button","ClassList":["cookie-consent-button"],"ClassListLight":["cookie-consent-button-light"],"ClassListDark":["cookie-consent-button-dark"],"Text":"Got it!","Title":"Accept cookies and close this message."}},"AuthenticationDiv":{"ID":"authentication-div","ClassList":["center-aligned"],"VWImage":{"ID":"vw-image","ClassList":[],"Src":"static/images/start_menu.png"},"AuthenticationButton":{"ID":"authentication-button","ClassList":[],"ClassListLight":["authentication-button-light"],"ClassListDark":["authentication-button-dark"],"Text":"Authenticate","Title":"Authenticate with OAuth2.0."}},"WelcomeDiv":{"ID":"welcome-div","ClassList":["center-aligned"],"ClassListLight":["welcome-div-light"],"ClassListDark":["welcome-div-dark"]},"PlatformDiv":{"ID":"platform-div","ClassList":["platform-div","center-aligned"],"ClassListLight":["platform-div-light"],"ClassListDark":["platform-div-dark"],"InitialGUI":{"InitialDiv":{"ID":"initial-div","ClassList":[],"InitialDivImage":{"ID":"initial-div-image","ClassList":[],"Src":"static/images/start_menu.png"}},"InitialControlsDiv":{"ID":"initial-controls-div","ClassList":[],"StartButton":{"ID":"start-button","ClassList":["initial-buttons"],"ClassListLight":["initial-buttons-light"],"ClassListDark":["initial-buttons-dark"],"Text":"Start","Title":"Display the simulation view"},"OptionsButton":{"ID":"options-button","ClassList":["initial-buttons"],"ClassListLight":["initial-buttons-light"],"ClassListDark":["initial-buttons-dark"],"Text":"Options","Title":"Choose the simulation options"},"GuideButton":{"ID":"outer-guide-button","ClassList":["initial-buttons"],"ClassListLight":["initial-buttons-light"],"ClassListDark":["initial-buttons-dark"],"Text":"Guide","Title":"Show the guide in a new browser tab.","URL":"https://github.com/dicelab-rhul/vacuumworld-web-gui/wiki"}},"OptionsDiv":{"ID":"options-dialog-div","ClassList":[],"OptionsDialog":{"ID":"options-dialog","ClassList":["options-dialog"],"SpeedSelectorDiv":{"ID":"speed-selector-div","ClassList":["options-dialog-element"],"SpeedSelectorLabel":{"ID":"speed-selector-label","ClassList":["options-dialog-label"],"Text":"Speed"},"SpeedSelector":{"ID":"speed-selector","ClassList":["options-dialog-sub-element"],"SpeedSelectorOption":{"IDPrefix":"speed-value-"}}},"AutoplayCheckboxDiv":{"ID":"autoplay-checkbox-div","ClassList":["options-dialog-element"],"AutoplayCheckboxLabel":{"ID":"autoplay-checkbox-label","ClassList":["options-dialog-label"],"Text":"Autoplay"},"AutoplayCheckbox":{"ID":"autoplay-checkbox","ClassList":["options-dialog-sub-element"],"TickedByDefault":false}},"StateToLoadInputDiv":{"ID":"state-to-load-input-div","ClassList":["options-dialog-element"],"StateToLoadInputLabel":{"ID":"state-to-load-input-label","ClassList":["options-dialog-label"],"Text":"State to load"},"StateToLoadInput":{"ID":"state-to-load-input","ClassList":["options-dialog-sub-element"],"Accept":".json","MaxFileSize":5000000}},"TooltipsCheckboxDiv":{"ID":"tooltips-checkbox-div","ClassList":["options-dialog-element"],"TooltipsCheckboxLabel":{"ID":"tooltips-checkbox-label","ClassList":["options-dialog-label"],"Text":"Tooltips"},"TooltipsCheckbox":{"ID":"tooltips-checkbox","ClassList":["options-dialog-sub-element"],"TickedByDefault":true}},"MaxNumberOfCyclesInputDiv":{"ID":"max-number-of-cycles-input-div","ClassList":["options-dialog-element"],"MaxNumberOfCyclesInputLabel":{"ID":"max-number-of-cycles-input-label","ClassList":["options-dialog-label"],"Text":"Max number of cycles"},"MaxNumberOfCyclesInput":{"ID":"max-number-of-cycles-input","ClassList":["options-dialog-sub-element"]}},"EffortsInputsDiv":{"ID":"efforts-inputs-div","ClassList":["options-dialog-element"],"EffortsInputsLabels":{"ID":"efforts-inputs-labels","ClassList":["options-dialog-label"],"For":"efforts-inputs","Text":"Efforts"},"EffortsInputs":{"IDSuffix":"-effort-div","EffortInputLabel":{"ClassList":["options-dialog-label"],"Text":""},"EffortInput":{"IDSuffix":"-effort-input","ClassList":["effort-option-div"]}}},"TeleoraInputDiv":{"ID":"teleora-input-div","ClassList":["options-dialog-element"],"TeleoraInputLabel":{"ID":"teleora-input-label","ClassList":["options-dialog-label"],"Text":"Teleora mind cores to load"},"TeleoraInput":{"ID":"teleora-input","ClassList":["options-dialog-sub-element"]}},"OptionsDialogOKButton":{"ID":"options-dialog-ok-button","ClassList":["options-dialog-buttons"],"Text":"OK","Title":"Close and save the options."},"OptionsDialogCancelButton":{"ID":"options-dialog-cancel-button","ClassList":["options-dialog-buttons"],"Text":"Cancel","Title":"Close without saving the options."}}}},"SimulationGUI":{"SimulationDiv":{"ID":"simulation-div","ClassList":[],"GridDiv":{"ID":"grid-div","ClassList":["grid","center-aligned"],"GridTable":{"ID":"grid-table","ClassList":["grid-table"],"GridTableRow":{"IDPrefix":"grid-table-row-","ClassList":["grid-row"],"GridTableCell":{"IDPrefix":"grid-table-cell-","ClassList":["grid-cell"],"ClassListLight":["grid-cell-light"],"ClassListDark":["grid-cell-dark"],"CellDiv":{"IDPrefix":"grid-cell-div-","ClassList":["cell","drop-zone"],"CellImage":{"IDPrefix":"grid-cell-image-","ClassList":["location-image"],"EmptyImageSrc":"static/images/locations/empty.png","GreenAgentNorthImageSrc":"static/images/locations/actor/green_north.png","GreenAgentSouthImageSrc":"static/images/locations/actor/green_south.png","GreenAgentWestImageSrc":"static/images/locations/actor/green_west.png","GreenAgentEastImageSrc":"static/images/locations/actor/green_east.png","OrangeAgentNorthImageSrc":"static/images/locations/actor/orange_north.png","OrangeAgentSouthImageSrc":"static/images/locations/actor/orange_south.png","OrangeAgentWestImageSrc":"static/images/locations/actor/orange_west.png","OrangeAgentEastImageSrc":"static/images/locations/actor/orange_east.png","WhiteAgentNorthImageSrc":"static/images/locations/actor/white_north.png","WhiteAgentSouthImageSrc":"static/images/locations/actor/white_south.png","WhiteAgentWestImageSrc":"static/images/locations/actor/white_west.png","WhiteAgentEastImageSrc":"static/images/locations/actor/white_east.png","UserNorthImageSrc":"static/images/locations/actor/user_north.png","UserSouthImageSrc":"static/images/locations/actor/user_south.png","UserWestImageSrc":"static/images/locations/actor/user_west.png","UserEastImageSrc":"static/images/locations/actor/user_east.png","GreenDirtImageSrc":"static/images/locations/dirt/green_dirt.png","OrangeDirtImageSrc":"static/images/locations/dirt/orange_dirt.png","ObstacleImageSrc":"static/images/locations/obstacle.png","DebugGreenAgentNorthImageSrc":"static/images/locations/debug/actor/green_north.png","DebugGreenAgentSouthImageSrc":"static/images/locations/debug/actor/green_south.png","DebugGreenAgentWestImageSrc":"static/images/locations/debug/actor/green_west.png","DebugGreenAgentEastImageSrc":"static/images/locations/debug/actor/green_east.png","DebugOrangeAgentNorthImageSrc":"static/images/locations/debug/actor/orange_north.png","DebugOrangeAgentSouthImageSrc":"static/images/locations/debug/actor/orange_south.png","DebugOrangeAgentWestImageSrc":"static/images/locations/debug/actor/orange_west.png","DebugOrangeAgentEastImageSrc":"static/images/locations/debug/actor/orange_east.png","DebugWhiteAgentNorthImageSrc":"static/images/locations/debug/actor/white_north.png","DebugWhiteAgentSouthImageSrc":"static/images/locations/debug/actor/white_south.png","DebugWhiteAgentWestImageSrc":"static/images/locations/debug/actor/white_west.png","DebugWhiteAgentEastImageSrc":"static/images/locations/debug/actor/white_east.png","DebugUserNorthImageSrc":"static/images/locations/debug/actor/user_north.png","DebugUserSouthImageSrc":"static/images/locations/debug/actor/user_south.png","DebugUserWestImageSrc":"static/images/locations/debug/actor/user_west.png","DebugUserEastImageSrc":"static/images/locations/debug/actor/user_east.png","DebugGreenDirtImageSrc":"static/images/locations/debug/dirt/green_dirt.png","DebugOrangeDirtImageSrc":"static/images/locations/debug/dirt/orange_dirt.png","DebugObstacleImageSrc":"static/images/locations/debug/obstacle.png"}}}}}},"DraggablesDiv":{"ID":"draggables-div","ClassList":[],"GreenAgentDiv":{"ID":"draggable-green-agent-div","ClassList":["draggable"],"GreenAgentImage":{"ID":"draggable-green-agent-image","ClassList":["draggable-image"],"ImageSrc":"static/images/locations/actor/green_north.png"}},"OrangeAgentDiv":{"ID":"draggable-orange-agent-div","ClassList":["draggable"],"OrangeAgentImage":{"ID":"draggable-orange-agent-image","ClassList":["draggable-image"],"ImageSrc":"static/images/locations/actor/orange_north.png"}},"WhiteAgentDiv":{"ID":"draggable-white-agent-div","ClassList":["draggable"],"WhiteAgentImage":{"ID":"draggable-white-agent-image","ClassList":["draggable-image"],"ImageSrc":"static/images/locations/actor/white_north.png"}},"UserDiv":{"ID":"draggable-user-div","ClassList":["draggable"],"UserImage":{"ID":"draggable-user-image","ClassList":["draggable-image"],"ImageSrc":"static/images/locations/actor/user_north.png"}},"GreenDirtDiv":{"ID":"draggable-green-dirt-div","ClassList":["draggable"],"GreenDirtImage":{"ID":"draggable-green-dirt-image","ClassList":["draggable-image"],"ImageSrc":"static/images/locations/dirt/green_dirt.png"}},"OrangeDirtDiv":{"ID":"draggable-orange-dirt-div","ClassList":["draggable"],"OrangeDirtImage":{"ID":"draggable-orange-dirt-image","ClassList":["draggable-image"],"ImageSrc":"static/images/locations/dirt/orange_dirt.png"}}},"SimulationControlsDiv":{"ID":"simulation-controls-div","ClassList":[],"RunButton":{"ID":"run-button","ClassList":["simulation-buttons"],"ClassListLight":["simulation-buttons-light"],"ClassListDark":["simulation-buttons-dark"],"Text":"Run","Title":"Run the simulation.","HiddenWhileRunning":true,"HiddenWhilePaused":true,"HiddenWhileStopped":false},"PauseButton":{"ID":"pause-button","ClassList":["simulation-buttons"],"ClassListLight":["simulation-buttons-light"],"ClassListDark":["simulation-buttons-dark"],"Text":"Pause","Title":"Pause the simulation.","HiddenWhileRunning":false,"HiddenWhilePaused":true,"HiddenWhileStopped":true},"ResumeButton":{"ID":"resume-button","ClassList":["simulation-buttons"],"ClassListLight":["simulation-buttons-light"],"ClassListDark":["simulation-buttons-dark"],"Text":"Resume","Title":"Resume the simulation.","HiddenWhileRunning":true,"HiddenWhilePaused":false,"HiddenWhileStopped":true},"StopButton":{"ID":"stop-button","ClassList":["simulation-buttons"],"ClassListLight":["simulation-buttons-light"],"ClassListDark":["simulation-buttons-dark"],"Text":"Stop","Title":"Stop the simulation.","HiddenWhileRunning":false,"HiddenWhilePaused":false,"HiddenWhileStopped":true},"ClearButton":{"ID":"clear-button","ClassList":["simulation-buttons"],"ClassListLight":["simulation-buttons-light"],"ClassListDark":["simulation-buttons-dark"],"Text":"Clear","Title":"Clear the grid.","HiddenWhileRunning":true,"HiddenWhilePaused":true,"HiddenWhileStopped":false},"SpeedUpButton":{"ID":"speed-up-button","ClassList":["simulation-buttons"],"ClassListLight":["simulation-buttons-light"],"ClassListDark":["simulation-buttons-dark"],"Text":"Speed+","Title":"Speed up the simulation.","HiddenWhileRunning":false,"HiddenWhilePaused":false,"HiddenWhileStopped":false},"SpeedDownButton":{"ID":"speed-down-button","ClassList":["simulation-buttons"],"ClassListLight":["simulation-buttons-light"],"ClassListDark":["simulation-buttons-dark"],"Text":"Speed-","Title":"Speed down the simulation.","HiddenWhileRunning":false,"HiddenWhilePaused":false,"HiddenWhileStopped":false},"UserDifficultyToggleButton":{"ID":"user-difficulty-toggle-button","ClassList":["simulation-buttons"],"ClassListLight":["simulation-buttons-light"],"ClassListDark":["simulation-buttons-dark"],"Text":"User","Title":"Toggle the user difficulty.","HiddenWhileRunning":false,"HiddenWhilePaused":false,"HiddenWhileStopped":false},"SaveStateButton":{"ID":"save-state-button","ClassList":["simulation-buttons"],"ClassListLight":["simulation-buttons-light"],"ClassListDark":["simulation-buttons-dark"],"Text":"Save","Title":"Save the current state of the environment.","HiddenWhileRunning":true,"HiddenWhilePaused":true,"HiddenWhileStopped":false},"LoadStateButton":{"ID":"load-state-button","ClassList":["simulation-buttons"],"ClassListLight":["simulation-buttons-light"],"ClassListDark":["simulation-buttons-dark"],"Text":"Load","Title":"Load a saved state.","HiddenWhileRunning":true,"HiddenWhilePaused":true,"HiddenWhileStopped":false},"SimulationGuideButton":{"ID":"inner-guide-button","ClassList":["simulation-buttons"],"ClassListLight":["simulation-buttons-light"],"ClassListDark":["simulation-buttons-dark"],"Text":"Guide","Title":"Show the guide in a new browser tab.","URL":"https://github.com/dicelab-rhul/vacuumworld-web-gui/wiki","HiddenWhileRunning":true,"HiddenWhilePaused":true,"HiddenWhileStopped":false},"SizeUpButton":{"ID":"size-up-button","ClassList":["simulation-buttons"],"ClassListLight":["simulation-buttons-light"],"ClassListDark":["simulation-buttons-dark"],"Text":"Size+","Title":"Increase the size of the environemnt by 1.","HiddenWhileRunning":true,"HiddenWhilePaused":true,"HiddenWhileStopped":false},"SizeDownButton":{"ID":"size-down-button","ClassList":["simulation-buttons"],"ClassListLight":["simulation-buttons-light"],"ClassListDark":["simulation-buttons-dark"],"Text":"Size-","Title":"Decrease the size of the environemnt by 1.","HiddenWhileRunning":true,"HiddenWhilePaused":true,"HiddenWhileStopped":false}}}}},"ErrorDiv":{"ID":"error-div","ClassList":[],"ClassListLight":["error-div-light"],"ClassListDark":["error-div-dark"]},"ToggleThemeDiv":{"ID":"toggle-theme-div","ClassList":["toggle-theme-div","center-aligned"],"ToggleThemeButton":{"ID":"toggle-theme-button","ClassList":[],"ClassListLight":["toggle-theme-button-light"],"ClassListDark":["toggle-theme-button-dark"],"TextLight":"Go Dark","TextDark":"Go Light","Title":"Switch between light and dark theme."}}}}');

});

parcelRegister("ksOKS", function(module, exports) {

$parcel$export(module.exports, "VWThemeUtils", () => $067f637b3f73ab2c$export$dc57ddf5f1ccd0e7);

var $alosR = parcelRequire("alosR");

var $2kjdU = parcelRequire("2kjdU");

var $5TcYE = parcelRequire("5TcYE");
const $067f637b3f73ab2c$var$GUI = (0, (/*@__PURE__*/$parcel$interopDefault($2kjdU))).GUI;
class $067f637b3f73ab2c$export$dc57ddf5f1ccd0e7 {
    constructor(){}
    static adjustComponentsToCurrentTheme() {
        const currentTheme = localStorage.getItem("theme") ?? (0, $alosR.VWTheme).DARK;
        $067f637b3f73ab2c$export$dc57ddf5f1ccd0e7.adjustComponentsToTheme(currentTheme);
    }
    static adjustComponentsToTheme(theme) {
        const themeToUse = theme ?? localStorage.getItem("theme") ?? (0, $alosR.VWTheme).DARK;
        const idsForReference = (0, (/*@__PURE__*/$parcel$interopDefault($5TcYE))).IDs;
        const classesForReference = (0, (/*@__PURE__*/$parcel$interopDefault($5TcYE))).Classes;
        $067f637b3f73ab2c$export$dc57ddf5f1ccd0e7.adjustBodyClassesToTheme(themeToUse);
        idsForReference.forEach((id)=>$067f637b3f73ab2c$export$dc57ddf5f1ccd0e7.adjustElementClassesToThemeByID(id, themeToUse, id));
        classesForReference.forEach((classReference)=>$067f637b3f73ab2c$export$dc57ddf5f1ccd0e7.adjustElementClassesToThemeByClass(classReference, themeToUse, classReference));
        $067f637b3f73ab2c$export$dc57ddf5f1ccd0e7.adjustToggleThemeButtonToTheme(themeToUse);
    }
    static adjustBodyClassesToTheme(theme) {
        const bodyReference = (0, (/*@__PURE__*/$parcel$interopDefault($5TcYE))).Body[0];
        $067f637b3f73ab2c$export$dc57ddf5f1ccd0e7.adjustElementClassesToTheme(document.body, theme, bodyReference);
    }
    static adjustElementClassesToThemeByID(elementID, theme, referenceID) {
        $067f637b3f73ab2c$export$dc57ddf5f1ccd0e7.adjustElementClassesToTheme(document.getElementById(elementID), theme, referenceID);
    }
    static adjustElementClassesToThemeByClass(elementClass, theme, referenceClass) {
        document.querySelectorAll(`.${elementClass}`).forEach((element)=>{
            $067f637b3f73ab2c$export$dc57ddf5f1ccd0e7.adjustElementClassesToTheme(element, theme, referenceClass);
        });
    }
    static getClassForTheme(theme, reference) {
        if (theme === (0, $alosR.VWTheme).DARK) return `${reference}-dark`;
        else if (theme === (0, $alosR.VWTheme).LIGHT) return `${reference}-light`;
        else throw new Error("The theme is not supported.");
    }
    static adjustElementClassesToTheme(element, theme, reference) {
        const themeClassesPrefix = `${reference}-`;
        const classForTheme = $067f637b3f73ab2c$export$dc57ddf5f1ccd0e7.getClassForTheme(theme, reference);
        element?.classList.forEach((elementClass)=>{
            if (elementClass.startsWith(themeClassesPrefix)) element.classList.remove(elementClass);
        });
        element?.classList.add(classForTheme);
    }
    static adjustToggleThemeButtonToTheme(theme) {
        const toggleThemeButton = document.getElementById($067f637b3f73ab2c$var$GUI.ToggleThemeDiv.ToggleThemeButton.ID);
        toggleThemeButton.textContent = theme === (0, $alosR.VWTheme).LIGHT ? $067f637b3f73ab2c$var$GUI.ToggleThemeDiv.ToggleThemeButton.TextLight : $067f637b3f73ab2c$var$GUI.ToggleThemeDiv.ToggleThemeButton.TextDark;
    }
}

});
parcelRegister("alosR", function(module, exports) {

$parcel$export(module.exports, "VWTheme", () => $0d39af05bab6711f$export$a322f0d3140d9b3b);
var $0d39af05bab6711f$export$a322f0d3140d9b3b;
(function(VWTheme) {
    VWTheme["LIGHT"] = "light";
    VWTheme["DARK"] = "dark";
})($0d39af05bab6711f$export$a322f0d3140d9b3b || ($0d39af05bab6711f$export$a322f0d3140d9b3b = {}));

});

parcelRegister("5TcYE", function(module, exports) {
module.exports = JSON.parse('{"Body":["body"],"IDs":["cookie-consent-div","cookie-consent-label","cookie-consent-button","welcome-div","authentication-div","authentication-button","error-div","platform-div","toggle-theme-button","options-dialog","speed-selector","state-to-load-input"],"Classes":["initial-buttons","grid-cell","simulation-buttons","options-dialog-element","options-dialog-label","options-dialog-buttons"]}');

});


parcelRegister("fQzR6", function(module, exports) {

$parcel$export(module.exports, "Main", () => $2177824356984545$export$861edd1ccea2f746);
/*
 *
 * This script is the enry point of the simulation.
 * It is responsible for displaying the initial view and calling the `Vacuumworld` script.
 *
 */ 
var $4VoVB = parcelRequire("4VoVB");

var $alosR = parcelRequire("alosR");

var $ksOKS = parcelRequire("ksOKS");

var $2kjdU = parcelRequire("2kjdU");
const $2177824356984545$var$GUI = (0, (/*@__PURE__*/$parcel$interopDefault($2kjdU))).GUI;
const $2177824356984545$var$errorDivData = $2177824356984545$var$GUI.ErrorDiv;
class $2177824356984545$export$861edd1ccea2f746 {
    static NONCE = undefined;
    constructor(){}
    static setNonce() {
        const indexScriptID = $2177824356984545$var$GUI.IndexScript.ID;
        if (document.getElementById(indexScriptID).nonce !== null && document.getElementById(indexScriptID).nonce !== undefined) // This is to propagate the `nonce` attribute to dynamically created/loaded scripts.
        // Main.NONCE is private, so it can't be accessed from outside the class.
        // This script should have a `nonce` attribute (set by the server).
        $2177824356984545$export$861edd1ccea2f746.NONCE = document.getElementById(indexScriptID).nonce;
    }
    static setTitle() {
        document.title = $2177824356984545$var$GUI.Metadata.Title;
    }
    static loadCharset() {
        let charset = document.createElement("meta");
        charset.setAttribute("charset", "utf-8");
        document.head.appendChild(charset);
    }
    static initErrorDiv() {
        document.getElementById($2177824356984545$var$errorDivData.ID).addEventListener("click", ()=>{
            document.getElementById($2177824356984545$var$errorDivData.ID).hidden = true;
        });
    }
    static createToggleThemeDiv() {
        const toggleThemeDiv = document.createElement("div");
        toggleThemeDiv.id = $2177824356984545$var$GUI.ToggleThemeDiv.ID;
        toggleThemeDiv.classList.add(...$2177824356984545$var$GUI.ToggleThemeDiv.ClassList);
        toggleThemeDiv.hidden = false;
        const toggleThemeButton = document.createElement("button");
        toggleThemeButton.id = $2177824356984545$var$GUI.ToggleThemeDiv.ToggleThemeButton.ID;
        toggleThemeButton.classList.add(...$2177824356984545$var$GUI.ToggleThemeDiv.ToggleThemeButton.ClassList);
        const currentTheme = localStorage.getItem("theme") ?? (0, $alosR.VWTheme).DARK;
        toggleThemeButton.textContent = currentTheme === (0, $alosR.VWTheme).LIGHT ? $2177824356984545$var$GUI.ToggleThemeDiv.ToggleThemeButton.TextDark : $2177824356984545$var$GUI.ToggleThemeDiv.ToggleThemeButton.TextLight;
        toggleThemeButton.addEventListener("click", ()=>{
            const currentTheme = localStorage.getItem("theme") ?? (0, $alosR.VWTheme).DARK;
            const newTheme = currentTheme === (0, $alosR.VWTheme).DARK ? (0, $alosR.VWTheme).LIGHT : (0, $alosR.VWTheme).DARK;
            localStorage.setItem("theme", newTheme);
            console.log(`Switching from ${currentTheme} theme to ${newTheme} theme.`);
            (0, $ksOKS.VWThemeUtils).adjustComponentsToTheme(newTheme);
        });
        toggleThemeDiv.appendChild(toggleThemeButton);
        document.body.appendChild(toggleThemeDiv);
    }
    static loadStyles() {
        const stylesDir = (0, (/*@__PURE__*/$parcel$interopDefault($2kjdU))).GUI.Stylesheets.StylesheetsDir;
        const styles = (0, (/*@__PURE__*/$parcel$interopDefault($2kjdU))).GUI.Stylesheets.Stylesheets;
        styles.forEach((style)=>{
            $2177824356984545$export$861edd1ccea2f746.loadStyle(`${stylesDir}/${style}`);
        });
    }
    static loadStyle(stylePath) {
        if (stylePath === null || stylePath === undefined) throw new Error("The style path is null or undefined.");
        else if (typeof stylePath !== "string") throw new Error("The style path is not a string.");
        else if (stylePath.length === 0) throw new Error("The style path is empty.");
        else if (stylePath.indexOf(".css") === -1) throw new Error("The style path does not contain a .css file.");
        else {
            let mainStyle = document.createElement("link");
            mainStyle.href = (0, $4VoVB.DOMPurifyPolicy).createScriptURL(stylePath); // Why not :)
            mainStyle.rel = "stylesheet";
            mainStyle.type = "text/css";
            document.head.appendChild($2177824356984545$export$861edd1ccea2f746.propagateNonceToElement(mainStyle));
        }
    }
    static propagateNonceToElement(element) {
        if (element !== null && element !== undefined && $2177824356984545$export$861edd1ccea2f746.NONCE?.length > 0) element.setAttribute("nonce", $2177824356984545$export$861edd1ccea2f746.NONCE);
        return element;
    }
    static disableFurtherScriptsLoading() {
        let metaTag = document.createElement("meta");
        metaTag.setAttribute("http-equiv", "Content-Security-Policy");
        metaTag.setAttribute("content", "script-src 'none';");
        document.head.appendChild(metaTag);
    }
}

});
parcelRegister("4VoVB", function(module, exports) {

$parcel$export(module.exports, "DOMPurifyPolicy", () => $aabf3eda98455475$export$8c482f24545fe422);

var $4HMOA = parcelRequire("4HMOA");

var $kCQjJ = parcelRequire("kCQjJ");
const $aabf3eda98455475$export$9b61e45c58ab9783 = (0, $4HMOA.trustedTypes).createPolicy("webagent", {
    createHTML (value) {
        throw new TypeError("HTML is not allowed by this policy.");
    },
    createScriptURL (value) {
        return encodeURIComponent(value);
    },
    createScript (value) {
        throw new TypeError("Scripts are not allowed by this policy.");
    }
});
const $aabf3eda98455475$export$8c482f24545fe422 = (0, $4HMOA.trustedTypes).createPolicy("dompurify", {
    createHTML (value) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($kCQjJ))).sanitize(value);
    },
    createScriptURL (value) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($kCQjJ))).sanitize(value);
    },
    createScript (value) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($kCQjJ))).sanitize(value);
    }
});
const $aabf3eda98455475$export$7d9a7941fb5d555f = (0, $4HMOA.trustedTypes).createPolicy("literal-string", {
    createHTML (value) {
        throw new TypeError("HTML is not allowed by this policy.");
    },
    createScriptURL: (value)=>value,
    createScript (value) {
        throw new TypeError("Scripts are not allowed by this policy.");
    }
});
const $aabf3eda98455475$export$799e9797dd57fa5d = (0, $4HMOA.trustedTypes).createPolicy("default", {
    createHTML (value) {
        console.log("Sanitising anyway the HTML with DOMPurify.");
        return (0, (/*@__PURE__*/$parcel$interopDefault($kCQjJ))).sanitize(value);
    },
    createScriptURL (value) {
        console.log("Sanitising anyway the script URL with DOMPurify.");
        return (0, (/*@__PURE__*/$parcel$interopDefault($kCQjJ))).sanitize(value);
    },
    createScript (value) {
        console.log("Sanitising anyway the script with DOMPurify.");
        return (0, (/*@__PURE__*/$parcel$interopDefault($kCQjJ))).sanitize(value);
    }
});
function $aabf3eda98455475$export$17b4961e97609cc7(s) {
    return $aabf3eda98455475$export$7d9a7941fb5d555f.createScriptURL(s);
}

});
parcelRegister("4HMOA", function(module, exports) {

$parcel$export(module.exports, "trustedTypes", () => $36d10b35d1f69dea$export$c7ee71a83251a964);
/**
 * @license
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 */ // TODO check attributes in safari, remove legacy safe handlers
const $36d10b35d1f69dea$var$unsafeAttributeEventHandlers = [
    "onabort",
    "onactivate",
    "onactivateinvisible",
    "onafterprint",
    "onafterupdate",
    "onanimationcancel",
    "onanimationend",
    "onanimationiteration",
    "onanimationstart",
    "onariarequest",
    "onauxclick",
    "onbeforeactivate",
    "onbeforecopy",
    "onbeforecut",
    "onbeforedeactivate",
    "onbeforeeditfocus",
    "onbeforepaste",
    "onbeforeprint",
    "onbeforeunload",
    "onbegin",
    "onblur",
    "onbounce",
    "oncancel",
    "oncanplay",
    "oncanplaythrough",
    "oncellchange",
    "onchange",
    "onclick",
    "onclose",
    "oncommand",
    "oncontextmenu",
    "oncontrolselect",
    "oncopy",
    "oncuechange",
    "oncut",
    "ondataavailable",
    "ondatasetchanged",
    "ondatasetcomplete",
    "ondblclick",
    "ondeactivate",
    "ondrag",
    "ondragdrop",
    "ondragend",
    "ondragenter",
    "ondragexit",
    "ondragleave",
    "ondragover",
    "ondragstart",
    "ondrop",
    "ondurationchange",
    "onemptied",
    "onend",
    "onended",
    "onerror",
    "onerrorupdate",
    "onexit",
    "onfilterchange",
    "onfinish",
    "onfocus",
    "onfocusin",
    "onfocusout",
    "onformdata",
    "onfullscreenchange",
    "onfullscreenerror",
    "ongotpointercapture",
    "onhelp",
    "oninput",
    "oninvalid",
    "onkeydown",
    "onkeypress",
    "onkeyup",
    "onlayoutcomplete",
    "onload",
    "onloadeddata",
    "onloadedmetadata",
    "onloadend",
    "onloadstart",
    "onlosecapture",
    "onlostpointercapture",
    "onmediacomplete",
    "onmediaerror",
    "onmessage",
    "onmousedown",
    "onmouseenter",
    "onmouseleave",
    "onmousemove",
    "onmouseout",
    "onmouseover",
    "onmouseup",
    "onmousewheel",
    "onmove",
    "onmoveend",
    "onmovestart",
    "onmozfullscreenchange",
    "onmozfullscreenerror",
    "onmscontentzoom",
    "onmsgesturechange",
    "onmsgesturedoubletap",
    "onmsgestureend",
    "onmsgesturehold",
    "onmsgesturestart",
    "onmsgesturetap",
    "onmsgotpointercapture",
    "onmsinertiastart",
    "onmslostpointercapture",
    "onmsmanipulationstatechanged",
    "onmspointercancel",
    "onmspointerdown",
    "onmspointerenter",
    "onmspointerleave",
    "onmspointermove",
    "onmspointerout",
    "onmspointerover",
    "onmspointerup",
    "onoffline",
    "ononline",
    "onoutofsync",
    "onoverscroll",
    "onpaste",
    "onpause",
    "onplay",
    "onplaying",
    "onpointercancel",
    "onpointerdown",
    "onpointerenter",
    "onpointerleave",
    "onpointermove",
    "onpointerout",
    "onpointerover",
    "onpointerrawupdate",
    "onpointerup",
    "onprogress",
    "onpropertychange",
    "onratechange",
    "onreadystatechange",
    "onrepeat",
    "onreset",
    "onresize",
    "onresizeend",
    "onresizestart",
    "onresume",
    "onreverse",
    "onrowdelete",
    "onrowenter",
    "onrowexit",
    "onrowinserted",
    "onscroll",
    "onscrollend",
    "onsearch",
    "onseek",
    "onseeked",
    "onseeking",
    "onselect",
    "onselectionchange",
    "onselectstart",
    "onshow",
    "onstalled",
    "onstart",
    "onstop",
    "onstorage",
    "onsubmit",
    "onsuspend",
    "onsynchrestored",
    "ontimeerror",
    "ontimeupdate",
    "ontoggle",
    "ontrackchange",
    "ontransitioncancel",
    "ontransitionend",
    "ontransitionrun",
    "ontransitionstart",
    "onunload",
    "onurlflip",
    "onvolumechange",
    "onwaiting",
    "onwebkitanimationend",
    "onwebkitanimationiteration",
    "onwebkitanimationstart",
    "onwebkitfullscreenchange",
    "onwebkitfullscreenerror",
    "onwebkittransitionend",
    "onwheel"
];
/**
 * Returns an array of all event handlers. Some of the event handlers may be
 * supported only in some browsers.
 *
 * For every event type that the browser supports, SVG supports that as an event
 * attribute, following the same requirements as for HTML event attributes.
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/Events
 *
 * @return {!Array<string>}
 */ function $36d10b35d1f69dea$var$getUnsafeAttributeEventHandlers() {
    if (typeof window !== "undefined") {
        const eventHandlers = [];
        for(const name in HTMLElement.prototype)if (name.slice(0, 2) === "on") eventHandlers.push(name);
        return eventHandlers;
    } else return $36d10b35d1f69dea$var$unsafeAttributeEventHandlers;
}
/**
 * @license
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 */ const $36d10b35d1f69dea$var$isBrowser = typeof window !== "undefined";
const $36d10b35d1f69dea$var$rejectInputFn = (s)=>{
    throw new TypeError("undefined conversion");
};
const $36d10b35d1f69dea$var$rejectInputDefaultPolicyFn = (s)=>null;
const { toLowerCase: $36d10b35d1f69dea$var$toLowerCase, toUpperCase: $36d10b35d1f69dea$var$toUpperCase } = String.prototype;
const $36d10b35d1f69dea$var$HTML_NS = "http://www.w3.org/1999/xhtml";
const $36d10b35d1f69dea$var$SVG_NS = "http://www.w3.org/2000/svg";
/**
 * @constructor
 * @property {!function(string):TrustedHTML} createHTML
 * @property {!function(string):TrustedScriptURL} createScriptURL
 * @property {!function(string):TrustedScript} createScript
 * @property {!string} name
 */ const $36d10b35d1f69dea$export$f9e72bceaff7be93 = function() {
    throw new TypeError("Illegal constructor");
};
/**
 * @constructor
 */ const $36d10b35d1f69dea$export$84bb1f0fdd92ef3b = function() {
    throw new TypeError("Illegal constructor");
};
/* eslint-enable no-unused-vars */ const $36d10b35d1f69dea$var$DEFAULT_POLICY_NAME = "default";
const $36d10b35d1f69dea$var$trustedTypesBuilderTestOnly = function() {
    // Capture common names early.
    const { assign: assign, create: create, defineProperty: defineProperty, freeze: freeze, getOwnPropertyNames: getOwnPropertyNames, getPrototypeOf: getPrototypeOf, prototype: ObjectPrototype } = Object;
    const { hasOwnProperty: hasOwnProperty } = ObjectPrototype;
    const { forEach: forEach, push: push } = Array.prototype;
    const creatorSymbol = Symbol();
    /**
   * Getter for the privateMap.
   * @param  {Object} obj Key of the privateMap
   * @return {Object<string, string>} Private storage.
   */ const privates = function(obj) {
        let v = privateMap.get(obj);
        if (v === undefined) {
            v = create(null); // initialize the private storage.
            privateMap.set(obj, v);
        }
        return v;
    };
    /**
   * Called before attacker-controlled code on an internal collections,
   * copies prototype members onto the instance directly, so that later
   * changes to prototypes cannot expose collection internals.
   * @param {!T} collection
   * @return {!T} collection
   * @template T
   */ function selfContained(collection) {
        const proto = getPrototypeOf(collection);
        if (proto == null || getPrototypeOf(proto) !== ObjectPrototype) throw new Error(); // Loop below is insufficient.
        for (const key of getOwnPropertyNames(proto))defineProperty(collection, key, {
            value: collection[key]
        });
        return collection;
    }
    /**
   * Map for private properties of Trusted Types object.
   * This is so that the access to the type constructor does not give
   * the ability to create typed values.
   * @type {WeakMap}
   */ const privateMap = selfContained(new WeakMap());
    /**
   * List of all configured policy names.
   * @type {Array<string>}
   */ const policyNames = selfContained([]);
    /**
   * Allowed policy names.
   * Applied only if enforceNameRestrictions is true.
   * @type {Array<string>}
   */ const allowedNames = selfContained([]);
    /**
   * Should duplicate prolicy names be allowed.
   * Applied only if enforceNameRestrictions is true.
   * @type {boolean}
   */ let allowDuplicateNames = true;
    /**
   * A reference to a default policy, if created.
   * @type {TrustedTypePolicy}
   */ let defaultPolicy = null;
    /**
   * Whether to enforce allowedNames in createPolicy().
   * @type {boolean}
   */ let enforceNameRestrictions = false;
    /**
   * A value that is trusted to have certain security-relevant properties
   * because the sources of such values are controlled.
   */ class TrustedType {
        /**
     * Constructor for TrustedType. Only allowed to be called from within a
     * policy.
     * @param {symbol} s creatorSymbol
     * @param {string} policyName The name of the policy this object was
     *   created by.
     */ constructor(s, policyName){
            // TODO: Figure out if symbol is needed, if the value is in privateMap.
            if (s !== creatorSymbol) throw new Error("cannot call the constructor");
            defineProperty(this, "policyName", {
                value: "" + policyName,
                enumerable: true
            });
        }
        /**
     * Returns the wrapped string value of the object.
     * @return {string}
     * @override
     */ toString() {
            return privates(this)["v"];
        }
        /**
     * Returns the wrapped string value of the object.
     * @return {string}
     * @override
     */ valueOf() {
            return privates(this)["v"];
        }
    }
    /**
   * @param {function(new:TrustedType, symbol, string)} SubClass
   * @param {string} canonName The class name which should be independent of
   *     any renaming pass and which is relied upon by the enforcer and for
   *     native type interop.
   */ function lockdownTrustedType(SubClass, canonName) {
        freeze(SubClass.prototype);
        delete SubClass.name;
        defineProperty(SubClass, "name", {
            value: canonName
        });
    }
    /**
   * Trusted Script URL object wrapping a string that can only be created from a
   * TT policy.
   */ class TrustedScriptURL extends TrustedType {
    }
    lockdownTrustedType(TrustedScriptURL, "TrustedScriptURL");
    /**
   * Trusted HTML object wrapping a string that can only be created from a
   * TT policy.
   */ class TrustedHTML extends TrustedType {
    }
    lockdownTrustedType(TrustedHTML, "TrustedHTML");
    /**
   * Trusted Script object wrapping a string that can only be created from a
   * TT policy.
   */ class TrustedScript extends TrustedType {
    }
    lockdownTrustedType(TrustedScript, "TrustedScript");
    lockdownTrustedType(TrustedType, "TrustedType");
    // Common constants.
    const emptyHTML = freeze(create(new TrustedHTML(creatorSymbol, "")));
    privates(emptyHTML)["v"] = "";
    const emptyScript = freeze(create(new TrustedScript(creatorSymbol, "")));
    privates(emptyScript)["v"] = "";
    /**
   * A map of attribute / property names to allowed types
   * for known namespaces.
   * @type {!Object<string,!TrustedTypesTypeMap>}
   * @export
   */ const TYPE_MAP = {
        [$36d10b35d1f69dea$var$HTML_NS]: {
            // TODO(koto): Figure out what to to with <link>
            "EMBED": {
                "attributes": {
                    "src": TrustedScriptURL.name
                }
            },
            "IFRAME": {
                "attributes": {
                    "srcdoc": TrustedHTML.name
                }
            },
            "OBJECT": {
                "attributes": {
                    "data": TrustedScriptURL.name,
                    "codebase": TrustedScriptURL.name
                }
            },
            // TODO(koto): Figure out what to do with portals.
            "SCRIPT": {
                "attributes": {
                    "src": TrustedScriptURL.name,
                    "text": TrustedScript.name
                },
                "properties": {
                    "innerText": TrustedScript.name,
                    "textContent": TrustedScript.name,
                    "text": TrustedScript.name
                }
            },
            "*": {
                "attributes": {},
                "properties": {
                    "innerHTML": TrustedHTML.name,
                    "outerHTML": TrustedHTML.name
                }
            }
        },
        [$36d10b35d1f69dea$var$SVG_NS]: {
            "*": {
                "attributes": {},
                "properties": {}
            }
        }
    };
    /**
   * A map of element property to HTML attribute names.
   * @type {!Object<string, string>}
   */ const ATTR_PROPERTY_MAP = {
        "codebase": "codeBase",
        "formaction": "formAction"
    };
    // Edge doesn't support srcdoc.
    if ($36d10b35d1f69dea$var$isBrowser && !("srcdoc" in HTMLIFrameElement.prototype)) delete TYPE_MAP[$36d10b35d1f69dea$var$HTML_NS]["IFRAME"]["attributes"]["srcdoc"];
    // in HTML, clone attributes into properties.
    for (const tag of Object.keys(TYPE_MAP[$36d10b35d1f69dea$var$HTML_NS])){
        if (!TYPE_MAP[$36d10b35d1f69dea$var$HTML_NS][tag]["properties"]) TYPE_MAP[$36d10b35d1f69dea$var$HTML_NS][tag]["properties"] = {};
        for (const attr of Object.keys(TYPE_MAP[$36d10b35d1f69dea$var$HTML_NS][tag]["attributes"]))TYPE_MAP[$36d10b35d1f69dea$var$HTML_NS][tag]["properties"][ATTR_PROPERTY_MAP[attr] ? ATTR_PROPERTY_MAP[attr] : attr] = TYPE_MAP[$36d10b35d1f69dea$var$HTML_NS][tag]["attributes"][attr];
    }
    // Add inline event handlers attribute names.
    for (const name of $36d10b35d1f69dea$var$getUnsafeAttributeEventHandlers()){
        TYPE_MAP[$36d10b35d1f69dea$var$HTML_NS]["*"]["attributes"][name] = "TrustedScript";
        TYPE_MAP[$36d10b35d1f69dea$var$SVG_NS]["*"]["attributes"][name] = "TrustedScript";
    }
    /**
   * @type {!Object<string,!Function>}
   */ const createTypeMapping = {
        "createHTML": TrustedHTML,
        "createScriptURL": TrustedScriptURL,
        "createScript": TrustedScript
    };
    const createFunctionAllowed = createTypeMapping.hasOwnProperty;
    /**
   * Function generating a type checker.
   * @template T
   * @param  {T} type The type to check against.
   * @return {function(*):boolean}
   */ function isTrustedTypeChecker(type) {
        return (obj)=>obj instanceof type && privateMap.has(obj);
    }
    /**
   * Wraps a user-defined policy rules with TT constructor
   * @param  {string} policyName The policy name
   * @param  {TrustedTypesInnerPolicy} innerPolicy InnerPolicy
   * @return {!TrustedTypePolicy} Frozen policy object
   */ function wrapPolicy(policyName, innerPolicy) {
        /**
     * @template T
     * @param {function(new:T, symbol, string)} Ctor a trusted type constructor
     * @param {string} methodName the policy factory method name
     * @return {function(string):!T} a factory that produces instances of Ctor.
     */ function creator(Ctor, methodName) {
            // This causes thisValue to be null when called below.
            const method = innerPolicy[methodName] || (policyName == $36d10b35d1f69dea$var$DEFAULT_POLICY_NAME ? $36d10b35d1f69dea$var$rejectInputDefaultPolicyFn : $36d10b35d1f69dea$var$rejectInputFn);
            const policySpecificType = freeze(new Ctor(creatorSymbol, policyName));
            const factory = {
                [methodName] (s, ...args) {
                    // Trick to get methodName to show in stacktrace.
                    let result = method("" + s, ...args);
                    if (result === undefined || result === null) {
                        if (policyName == $36d10b35d1f69dea$var$DEFAULT_POLICY_NAME) // These values mean that the input was rejected. This will cause
                        // a violation later, don't create types for them.
                        return result;
                        result = "";
                    }
                    const allowedValue = "" + result;
                    const o = freeze(create(policySpecificType));
                    privates(o)["v"] = allowedValue;
                    return o;
                }
            }[methodName];
            return freeze(factory);
        }
        const policy = create($36d10b35d1f69dea$export$f9e72bceaff7be93.prototype);
        for (const name of getOwnPropertyNames(createTypeMapping))policy[name] = creator(createTypeMapping[name], name);
        defineProperty(policy, "name", {
            value: policyName,
            writable: false,
            configurable: false,
            enumerable: true
        });
        return /** @type {!TrustedTypePolicy} */ freeze(policy);
    }
    /**
   * Returns the name of the trusted type required for a given element
   *   attribute.
   * @param {string} tagName The name of the tag of the element.
   * @param {string} attribute The name of the attribute.
   * @param {string=} elementNs Element namespace.
   * @param {string=} attributeNs The attribute namespace.
   * @return {string?} Required type name or null, if a Trusted
   *   Type is not required.
   */ function getAttributeType(tagName, attribute, elementNs = "", attributeNs = "") {
        const canonicalAttr = $36d10b35d1f69dea$var$toLowerCase.apply(String(attribute));
        return getTypeInternal_(tagName, "attributes", canonicalAttr, elementNs, attributeNs) || null;
    }
    /**
   * Returns a type name from a type map.
   * @param {string} tag A tag name.
   * @param {string} container 'attributes' or 'properties'
   * @param {string} name The attribute / property name.
   * @param {string=} elNs Element namespace.
   * @param {string=} attrNs Attribute namespace.
   * @return {string|undefined}
   * @private
   */ function getTypeInternal_(tag, container, name, elNs = "", attrNs = "") {
        const canonicalTag = $36d10b35d1f69dea$var$toUpperCase.apply(String(tag));
        let ns = attrNs ? attrNs : elNs;
        if (!ns) ns = $36d10b35d1f69dea$var$HTML_NS;
        const map = hasOwnProperty.apply(TYPE_MAP, [
            ns
        ]) ? TYPE_MAP[ns] : null;
        if (!map) return;
        if (hasOwnProperty.apply(map, [
            canonicalTag
        ]) && map[canonicalTag] && hasOwnProperty.apply(map[canonicalTag][container], [
            name
        ]) && map[canonicalTag][container][name]) return map[canonicalTag][container][name];
        if (hasOwnProperty.apply(map, [
            "*"
        ]) && hasOwnProperty.apply(map["*"][container], [
            name
        ]) && map["*"][container][name]) return map["*"][container][name];
    }
    /**
   * Returns the name of the trusted type required for a given element property.
   * @param {string} tagName The name of the tag of the element.
   * @param {string} property The property.
   * @param {string=} elementNs Element namespace.
   * @return {string?} Required type name or null, if a Trusted
   *   Type is not required.
   */ function getPropertyType(tagName, property, elementNs = "") {
        // TODO: Support namespaces.
        return getTypeInternal_(tagName, "properties", String(property), elementNs) || null;
    }
    /**
   * Returns the type map-like object, that resolves a name of a type for a
   * given tag + attribute / property in a given namespace.
   * The keys of the map are uppercase tag names. Map entry has mappings between
   * a lowercase attribute name / case-sensitive property name and a name of the
   * type that is required for that attribute / property.
   * Example entry for 'IMG': {"attributes": {"src": "TrustedHTML"}}
   * @param {string=} namespaceUri The namespace URI (will use the current
   *   document namespace URI if omitted).
   * @return {TrustedTypesTypeMap}
   */ function getTypeMapping(namespaceUri = "") {
        if (!namespaceUri) try {
            namespaceUri = document.documentElement.namespaceURI;
        } catch (e) {
            namespaceUri = $36d10b35d1f69dea$var$HTML_NS;
        }
        /**
     * @template T
     * @private
     * @param {T} o
     * @return {T}
     */ function deepClone(o) {
            return JSON.parse(JSON.stringify(o));
        }
        const map = TYPE_MAP[namespaceUri];
        if (!map) return {};
        return deepClone(map);
    }
    /**
   * Creates a TT policy.
   *
   * Returns a frozen object representing a policy - a collection of functions
   * that may create TT objects based on the user-provided rules specified
   * in the policy object.
   *
   * @param  {string} name A unique name of the policy.
   * @param  {TrustedTypesInnerPolicy} policy Policy rules object.
   * @return {TrustedTypePolicy} The policy that may create TT objects
   *   according to the policy rules.
   */ function createPolicy(name, policy) {
        const pName = "" + name; // Assert it's a string
        if (!pName.match(/^[-#a-zA-Z0-9=_/@.%]+$/g)) throw new TypeError("Policy " + pName + " contains invalid characters.");
        if (enforceNameRestrictions && allowedNames.indexOf(pName) === -1 && allowedNames.indexOf("*") === -1) throw new TypeError("Policy " + pName + " disallowed.");
        if (pName === $36d10b35d1f69dea$var$DEFAULT_POLICY_NAME && defaultPolicy) throw new TypeError("Policy " + pName + " already exists.");
        if (enforceNameRestrictions && !allowDuplicateNames && policyNames.indexOf(pName) !== -1) throw new TypeError("Policy " + pName + " exists.");
        // Register the name early so that if policy getters unwisely calls
        // across protection domains to code that reenters this function,
        // policy author still has rights to the name.
        policyNames.push(pName);
        // Only copy own properties of names present in createTypeMapping.
        const innerPolicy = create(null);
        if (policy && typeof policy === "object") {
            // Treat non-objects as empty policies.
            for (const key of getOwnPropertyNames(policy))if (createFunctionAllowed.call(createTypeMapping, key)) innerPolicy[key] = policy[key];
        } else // eslint-disable-next-line no-console
        console.warn("trustedTypes.createPolicy " + pName + " was given an empty policy");
        freeze(innerPolicy);
        const wrappedPolicy = wrapPolicy(pName, innerPolicy);
        if (pName === $36d10b35d1f69dea$var$DEFAULT_POLICY_NAME) defaultPolicy = wrappedPolicy;
        return wrappedPolicy;
    }
    /**
   * Applies the policy name restrictions.
   * @param {!Array<string>} allowedPolicyNames
   * @param {boolean} allowDuplicates
   */ function setPolicyNameRestrictions(allowedPolicyNames, allowDuplicates) {
        enforceNameRestrictions = true;
        allowedNames.length = 0;
        forEach.call(allowedPolicyNames, (el)=>{
            push.call(allowedNames, "" + el);
        });
        allowDuplicateNames = allowDuplicates;
        policyNames.length = 0; // Clear already used policy names list.
    }
    /**
   * Clears the policy name restrictions.
   */ function clearPolicyNameRestrictions() {
        enforceNameRestrictions = false;
    }
    /**
   * Returns the default policy, or null if it was not created.
   * @return {TrustedTypePolicy}
   */ function getDefaultPolicy() {
        return defaultPolicy;
    }
    /**
   * Resets the default policy.
   */ function resetDefaultPolicy() {
        defaultPolicy = null;
        policyNames.splice(policyNames.indexOf($36d10b35d1f69dea$var$DEFAULT_POLICY_NAME), 1);
    }
    const api = create($36d10b35d1f69dea$export$84bb1f0fdd92ef3b.prototype);
    assign(api, {
        createPolicy: // The main function to create policies.
        createPolicy,
        // Type checkers, also validating the object was initialized through a
        // policy.
        isHTML: isTrustedTypeChecker(TrustedHTML),
        isScriptURL: isTrustedTypeChecker(TrustedScriptURL),
        isScript: isTrustedTypeChecker(TrustedScript),
        getAttributeType: getAttributeType,
        getPropertyType: getPropertyType,
        getTypeMapping: getTypeMapping,
        emptyHTML: emptyHTML,
        emptyScript: emptyScript,
        defaultPolicy: defaultPolicy,
        TrustedHTML: TrustedHTML,
        TrustedScriptURL: TrustedScriptURL,
        TrustedScript: TrustedScript
    });
    defineProperty(api, "defaultPolicy", {
        get: getDefaultPolicy,
        set: ()=>{}
    });
    return {
        trustedTypes: freeze(api),
        setPolicyNameRestrictions: setPolicyNameRestrictions,
        clearPolicyNameRestrictions: clearPolicyNameRestrictions,
        getDefaultPolicy: getDefaultPolicy,
        resetDefaultPolicy: resetDefaultPolicy
    };
};
const { trustedTypes: $36d10b35d1f69dea$export$c7ee71a83251a964, setPolicyNameRestrictions: $36d10b35d1f69dea$var$setPolicyNameRestrictions, clearPolicyNameRestrictions: $36d10b35d1f69dea$var$clearPolicyNameRestrictions, getDefaultPolicy: $36d10b35d1f69dea$var$getDefaultPolicy, resetDefaultPolicy: $36d10b35d1f69dea$var$resetDefaultPolicy } = $36d10b35d1f69dea$var$trustedTypesBuilderTestOnly();
/**
 * @license
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 */ /**
 * CSP Directive name controlling Trusted Types behavior.
 * @type {string}
 */ const $36d10b35d1f69dea$var$ENFORCEMENT_DIRECTIVE_NAME = "require-trusted-types-for";
const $36d10b35d1f69dea$var$POLICIES_DIRECTIVE_NAME = "trusted-types";
/**
 * A configuration object for trusted type enforcement.
 */ class $36d10b35d1f69dea$export$b441ce9e44fca32c {
    /**
   * @param {boolean} isLoggingEnabled If true enforcement wrappers will log
   *   violations to the console.
   * @param {boolean} isEnforcementEnabled If true enforcement is enabled at
   *   runtime.
   * @param {Array<string>} allowedPolicyNames Whitelisted policy names.
   * @param {boolean} allowDuplicates Should duplicate names be allowed.
   * @param {?string} cspString String with the CSP policy.
   * @param {?Window} windowObject to monkey patch
   */ constructor(isLoggingEnabled, isEnforcementEnabled, allowedPolicyNames, allowDuplicates, cspString = null, windowObject = null){
        /**
      * True if logging is enabled.
      * @type {boolean}
      */ this.isLoggingEnabled = isLoggingEnabled;
        /**
      * True if enforcement is enabled.
      * @type {boolean}
      */ this.isEnforcementEnabled = isEnforcementEnabled;
        /**
     * Allowed policy names.
     * @type {Array<string>}
     */ this.allowedPolicyNames = allowedPolicyNames;
        /**
     * Should duplicate names be accepted.
     * @type {boolean}
     */ this.allowDuplicates = allowDuplicates;
        /**
     * CSP string that defined the policy.
     * @type {?string}
     */ this.cspString = cspString;
        /**
     * Window like object to monkey patch.
     * @type {?Window}
     */ this.windowObject = windowObject;
    }
    /**
   * Parses a CSP policy.
   * @link https://www.w3.org/TR/CSP3/#parse-serialized-policy
   * @param  {string} cspString String with a CSP definition.
   * @return {Object<string,Array<string>>} Parsed CSP, keyed by directive
   *   names.
   */ static parseCSP(cspString) {
        const SEMICOLON = /\s*;\s*/;
        const WHITESPACE = /\s+/;
        return cspString.trim().split(SEMICOLON).map((serializedDirective)=>serializedDirective.split(WHITESPACE)).reduce(function(parsed, directive) {
            if (directive[0]) parsed[directive[0]] = directive.slice(1).map((s)=>s).sort();
            return parsed;
        }, {});
    }
    /**
   * Creates a TrustedTypeConfig object from a CSP string.
   * @param  {string} cspString
   * @return {!TrustedTypeConfig}
   */ static fromCSP(cspString) {
        const isLoggingEnabled = true;
        const policy = $36d10b35d1f69dea$export$b441ce9e44fca32c.parseCSP(cspString);
        const enforce = $36d10b35d1f69dea$var$ENFORCEMENT_DIRECTIVE_NAME in policy && policy[$36d10b35d1f69dea$var$ENFORCEMENT_DIRECTIVE_NAME].includes("'script'");
        let policies = [
            "*"
        ];
        let allowDuplicates = true;
        if ($36d10b35d1f69dea$var$POLICIES_DIRECTIVE_NAME in policy) {
            policies = policy[$36d10b35d1f69dea$var$POLICIES_DIRECTIVE_NAME].filter((p)=>p.charAt(0) !== "'");
            allowDuplicates = policy[$36d10b35d1f69dea$var$POLICIES_DIRECTIVE_NAME].includes("'allow-duplicates'");
            if (policy[$36d10b35d1f69dea$var$POLICIES_DIRECTIVE_NAME].length == 1 && policy[$36d10b35d1f69dea$var$POLICIES_DIRECTIVE_NAME][0] == "'none'") policies = [];
        }
        return new $36d10b35d1f69dea$export$b441ce9e44fca32c(isLoggingEnabled, enforce, /* isEnforcementEnabled */ policies, /* allowedPolicyNames */ allowDuplicates, /* allowDuplicates */ cspString);
    }
}
/**
 * @license
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 */ const { defineProperty: $36d10b35d1f69dea$var$defineProperty } = Object;
/**
 * Installs the setter of a given property.
 * @param {!Object} object An object for which to wrap the property.
 * @param {string} name The name of the property to wrap.
 * @param {function(*): *|undefined} setter A setter function}
 */ function $36d10b35d1f69dea$var$installSetter(object, name, setter) {
    const descriptor = {
        set: setter
    };
    $36d10b35d1f69dea$var$defineProperty(object, name, descriptor);
}
/**
 * Installs a setter and getter of a given property.
 * @param {!Object} object An object for which to wrap the property.
 * @param {string} name The name of the property to wrap.
 * @param {function(*): *|undefined} setter A setter function}
 * @param {function(*): *|undefined} getter A getter function}
 */ function $36d10b35d1f69dea$var$installSetterAndGetter(object, name, setter, getter) {
    const descriptor = {
        set: setter,
        get: getter,
        configurable: true
    };
    $36d10b35d1f69dea$var$defineProperty(object, name, descriptor);
}
/**
 * Installs the setter of a given property.
 * @param {!Object} object An object for which to wrap the property.
 * @param {string} name The name of the property to wrap.
 * @param {function(*): *|undefined} fn A function}
 */ function $36d10b35d1f69dea$var$installFunction(object, name, fn) {
    $36d10b35d1f69dea$var$defineProperty(object, name, {
        value: fn
    });
}
/**
 * @license
 * Copyright 2017 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 */ const { apply: $36d10b35d1f69dea$var$apply } = Reflect;
const { getOwnPropertyNames: $36d10b35d1f69dea$var$getOwnPropertyNames, getOwnPropertyDescriptor: $36d10b35d1f69dea$var$getOwnPropertyDescriptor, getPrototypeOf: $36d10b35d1f69dea$var$getPrototypeOf } = Object;
const { hasOwnProperty: $36d10b35d1f69dea$var$hasOwnProperty, isPrototypeOf: $36d10b35d1f69dea$var$isPrototypeOf } = Object.prototype;
const { slice: $36d10b35d1f69dea$var$slice } = String.prototype;
let $36d10b35d1f69dea$var$stringifyForRangeHack;
/**
 * Parses URL, catching all the errors.
 * @param  {string} url URL string to parse.
 * @param  {Window} windowObject the window object.
 * @return {URL|null}
 */ function $36d10b35d1f69dea$var$parseUrl_(url, windowObject) {
    // No URL in IE 11.
    const UrlConstructor = typeof windowObject.URL == "function" ? windowObject.URL.prototype.constructor : null;
    try {
        return new UrlConstructor(url, windowObject.document.baseURI || undefined);
    } catch (e) {
        return null;
    }
}
// We don't actually need other namespaces.
// setAttribute is hooked on Element.prototype, which all elements inherit from,
// and all sensitive property wrappers are hooked directly on Element as well.
const $36d10b35d1f69dea$var$typeMap = $36d10b35d1f69dea$export$c7ee71a83251a964.getTypeMapping($36d10b35d1f69dea$var$HTML_NS);
const $36d10b35d1f69dea$var$STRING_TO_TYPE = {
    "TrustedHTML": $36d10b35d1f69dea$export$c7ee71a83251a964.TrustedHTML,
    "TrustedScript": $36d10b35d1f69dea$export$c7ee71a83251a964.TrustedScript,
    "TrustedScriptURL": $36d10b35d1f69dea$export$c7ee71a83251a964.TrustedScriptURL
};
for (const tagName of Object.keys($36d10b35d1f69dea$var$typeMap)){
    const attrs = $36d10b35d1f69dea$var$typeMap[tagName]["properties"];
    for (const [k, v] of Object.entries(attrs))attrs[k] = $36d10b35d1f69dea$var$STRING_TO_TYPE[v];
}
/**
 * Map of type names to type checking function.
 * @type {!Object<string,!Function>}
 */ const $36d10b35d1f69dea$var$TYPE_CHECKER_MAP = {
    "TrustedHTML": $36d10b35d1f69dea$export$c7ee71a83251a964.isHTML,
    "TrustedScriptURL": $36d10b35d1f69dea$export$c7ee71a83251a964.isScriptURL,
    "TrustedScript": $36d10b35d1f69dea$export$c7ee71a83251a964.isScript
};
/**
 * Map of type names to type producing function.
 * @type {Object<string,string>}
 */ const $36d10b35d1f69dea$var$TYPE_PRODUCER_MAP = {
    "TrustedHTML": "createHTML",
    "TrustedScriptURL": "createScriptURL",
    "TrustedScript": "createScript"
};
/* eslint-enable no-unused-vars */ /**
 * An object for enabling trusted type enforcement.
 */ class $36d10b35d1f69dea$export$4b3cf9821847f6aa {
    /**
   * @param {!TrustedTypeConfig} config The configuration for
   */ constructor(config){
        /**
     * A configuration for the trusted type enforcement.
     * @private {!TrustedTypeConfig}
     */ this.config_ = config;
        /**
     * @private {Object<string, function(*): *|undefined>}
     */ this.originalSetters_ = {};
        /**
     * The object that will be monkey patched by the polyfill.
     * @private {Window}
     */ this.windowObject_ = config.windowObject || (typeof window !== "undefined" ? window : null);
        if (!this.isValidWindowObject_()) throw new Error(// eslint-disable-next-line
        "The polyfill expects a global `window` object or emulated `window-like` object passed to the enforcer as second argument");
        // In IE 11, insertAdjacent(HTML|Text) is on HTMLElement prototype
        this.insertAdjacentObjectPrototype = ((w)=>{
            return $36d10b35d1f69dea$var$apply($36d10b35d1f69dea$var$hasOwnProperty, w.Element.prototype, [
                "insertAdjacentHTML"
            ]) ? w.Element.prototype : w.HTMLElement.prototype;
        })(this.windowObject_);
        this.functionConstructorNameGetter = this.windowObject_.document.createElement("div").constructor.name ? (fn)=>fn.name : (fn)=>("" + fn).match(/^\[object (\S+)\]$/)[1];
    }
    /**
   * Validates that the windowObject is in correct form.
   * @return {boolean}
   */ isValidWindowObject_() {
        const w = this.windowObject_;
        const requiredSymbols = [
            "Element",
            "HTMLElement",
            "Document",
            "Node",
            "document"
        ];
        return !!w && typeof w === "object" && requiredSymbols.every((s)=>s in w);
    }
    /**
   * Checks whether the value is instanceOf the specific window object.
   * @param {*} value
   * @param {string} winProp
   * @return {boolean}
   * @private
   */ instanceOfDomProperty(value, winProp) {
        const obj = this.windowObject_[winProp];
        return !!obj && value instanceof obj;
    }
    /**
   * Converts an uppercase tag name to an element constructor function name.
   * Used for property setter hijacking only.
   * @param {string} tagName
   * @return {?string}
   */ convertTagToConstructor(tagName) {
        if (tagName == "*") return "HTMLElement";
        else return this.getConstructorName_(this.windowObject_.document.createElement(tagName).constructor);
    }
    /**
   * Return object constructor name (their function.name is
   * not available in IE 11).
   * @param {Function} fn
   * @return {?string}
   * @private
   */ getConstructorName_(fn) {
        return this.functionConstructorNameGetter(fn);
    }
    /**
   * Wraps HTML sinks with an enforcement setter, which will enforce
   * trusted types and do logging, if enabled.
   *
   * Every HTML sink is feature tested for existance first and TT is
   * enforced only when it exists. This is becuase the polyfill can work
   * with emulated window-like objects, which might not be fully compatible
   * with browser DOM.
   */ install() {
        $36d10b35d1f69dea$var$setPolicyNameRestrictions(this.config_.allowedPolicyNames, this.config_.allowDuplicates);
        if (!this.config_.isEnforcementEnabled && !this.config_.isLoggingEnabled) return;
        if ("ShadowRoot" in this.windowObject_) this.wrapSetter_(this.windowObject_.ShadowRoot.prototype, "innerHTML", $36d10b35d1f69dea$export$c7ee71a83251a964.TrustedHTML);
        $36d10b35d1f69dea$var$stringifyForRangeHack = function(doc) {
            if (!doc.createRange) return false;
            const r = doc.createRange();
            // In IE 11 Range.createContextualFragment doesn't stringify its argument.
            const f = r.createContextualFragment(/** @type {string} */ {
                toString: ()=>"<div></div>"
            });
            return f.childNodes.length == 0;
        }(this.windowObject_.document);
        if (this.windowObject_.Range) this.wrapWithEnforceFunction_(this.windowObject_.Range.prototype, "createContextualFragment", $36d10b35d1f69dea$export$c7ee71a83251a964.TrustedHTML, 0);
        if (this.insertAdjacentObjectPrototype) this.wrapWithEnforceFunction_(this.insertAdjacentObjectPrototype, "insertAdjacentHTML", $36d10b35d1f69dea$export$c7ee71a83251a964.TrustedHTML, 1);
        if ($36d10b35d1f69dea$var$getOwnPropertyDescriptor(this.windowObject_.Document.prototype, "write")) // Chrome
        this.wrapWithEnforceFunction_(this.windowObject_.Document.prototype, "write", $36d10b35d1f69dea$export$c7ee71a83251a964.TrustedHTML, 0);
        else if (this.windowObject_.HTMLDocument && $36d10b35d1f69dea$var$getOwnPropertyDescriptor(this.windowObject_.HTMLDocument.prototype, "write")) // Firefox
        this.wrapWithEnforceFunction_(this.windowObject_.HTMLDocument.prototype, "write", $36d10b35d1f69dea$export$c7ee71a83251a964.TrustedHTML, 0);
        if ("DOMParser" in this.windowObject_) this.wrapWithEnforceFunction_(this.windowObject_.DOMParser.prototype, "parseFromString", $36d10b35d1f69dea$export$c7ee71a83251a964.TrustedHTML, 0);
        if (this.windowObject_.hasOwnProperty("setInterval")) this.wrapWithEnforceFunction_(this.windowObject_, "setInterval", $36d10b35d1f69dea$export$c7ee71a83251a964.TrustedScript, 0);
        if (this.windowObject_.hasOwnProperty("setTimeout")) this.wrapWithEnforceFunction_(this.windowObject_, "setTimeout", $36d10b35d1f69dea$export$c7ee71a83251a964.TrustedScript, 0);
        this.wrapSetAttribute_();
        this.installScriptMutatorGuards_();
        this.installPropertySetWrappers_();
    }
    /**
   * Removes the original setters.
   */ uninstall() {
        $36d10b35d1f69dea$var$clearPolicyNameRestrictions();
        if (!this.config_.isEnforcementEnabled && !this.config_.isLoggingEnabled) return;
        if ("ShadowRoot" in this.windowObject_) this.restoreSetter_(this.windowObject_.ShadowRoot.prototype, "innerHTML");
        if (this.windowObject_.Range) this.restoreFunction_(this.windowObject_.Range.prototype, "createContextualFragment");
        this.restoreFunction_(this.insertAdjacentObjectPrototype, "insertAdjacentHTML");
        this.restoreFunction_(this.windowObject_.Element.prototype, "setAttribute");
        this.restoreFunction_(this.windowObject_.Element.prototype, "setAttributeNS");
        if ($36d10b35d1f69dea$var$getOwnPropertyDescriptor(this.windowObject_.Document.prototype, "write")) this.restoreFunction_(this.windowObject_.Document.prototype, "write");
        else if (this.windowObject_.HTMLDocument && $36d10b35d1f69dea$var$getOwnPropertyDescriptor(this.windowObject_.HTMLDocument.prototype, "write")) this.restoreFunction_(HTMLDocument.prototype, "write");
        if ("DOMParser" in this.windowObject_) this.restoreFunction_(DOMParser.prototype, "parseFromString");
        if (this.windowObject_.hasOwnProperty("setTimeout")) this.restoreFunction_(this.windowObject_, "setTimeout");
        if (this.windowObject_.hasOwnProperty("setInterval")) this.restoreFunction_(this.windowObject_, "setInterval");
        this.uninstallPropertySetWrappers_();
        this.uninstallScriptMutatorGuards_();
        $36d10b35d1f69dea$var$resetDefaultPolicy();
    }
    /**
   * Installs type-enforcing wrappers for APIs that allow to modify
   * script element texts.
   * @private
   */ installScriptMutatorGuards_() {
        const that = this;
        [
            "appendChild",
            "insertBefore",
            "replaceChild"
        ].forEach((fnName)=>{
            this.wrapFunction_(this.windowObject_.Node.prototype, fnName, /**
           * @this {Node}
           * @param {function(!Function, ...*)} originalFn
           * @return {*}
           */ function(originalFn, ...args) {
                return that.enforceTypeInScriptNodes_.bind(that, this, /* checkParent */ false, originalFn).apply(that, args);
            });
        });
        if (this.insertAdjacentObjectPrototype) this.wrapFunction_(this.insertAdjacentObjectPrototype, "insertAdjacentText", /**
           * @this {Element}
           * @param {function(!Function, ...*)} originalFn
           * @return {*}
           */ function(originalFn, ...args) {
            return that.insertAdjacentTextWrapper_.bind(that, this, originalFn).apply(that, args);
        });
        [
            "after",
            "before",
            "replaceWith"
        ].forEach((fnName)=>{
            if (fnName in this.windowObject_.Element.prototype) this.wrapFunction_(this.windowObject_.Element.prototype, fnName, /**
             * @this {Element}
             * @param {function(!Function, ...*)} originalFn
             * @return {*}
             */ function(originalFn, ...args) {
                return that.enforceTypeInScriptNodes_.bind(that, this, /* checkParent */ true, originalFn).apply(that, args);
            });
        });
        [
            "append",
            "prepend"
        ].forEach((fnName)=>{
            if (fnName in this.windowObject_.Element.prototype) this.wrapFunction_(this.windowObject_.Element.prototype, fnName, /**
           * @this {Element}
           * @param {function(!Function, ...*)} originalFn
           * @return {*}
           */ function(originalFn, ...args) {
                return that.enforceTypeInScriptNodes_.bind(that, this, /* checkParent */ false, originalFn).apply(that, args);
            });
        });
    }
    /**
   * Uninstalls type-enforcing wrappers for APIs that allow to modify
   * script element texts.
   * @private
   */ uninstallScriptMutatorGuards_() {
        this.restoreFunction_(this.windowObject_.Node.prototype, "appendChild");
        this.restoreFunction_(this.windowObject_.Node.prototype, "insertBefore");
        this.restoreFunction_(this.windowObject_.Node.prototype, "replaceChild");
        this.restoreFunction_(this.insertAdjacentObjectPrototype, "insertAdjacentText");
        [
            "after",
            "before",
            "replaceWith",
            "append",
            "prepend"
        ].forEach((fnName)=>{
            if (fnName in this.windowObject_.Element.prototype) this.restoreFunction_(this.windowObject_.Element.prototype, fnName);
        });
    }
    /**
   * Installs wrappers for directly setting properties
   * based on the type map.
   * @private
   */ installPropertySetWrappers_() {
        /* eslint-disable guard-for-in */ for (const tag of $36d10b35d1f69dea$var$getOwnPropertyNames($36d10b35d1f69dea$var$typeMap))for (const property of $36d10b35d1f69dea$var$getOwnPropertyNames($36d10b35d1f69dea$var$typeMap[tag]["properties"])){
            const constr = this.convertTagToConstructor(tag);
            if (constr != null && this.windowObject_[constr]) this.wrapSetter_(this.windowObject_[constr].prototype, property, $36d10b35d1f69dea$var$typeMap[tag]["properties"][property]);
        }
    }
    /**
   * Uninstalls wrappers for directly setting properties
   * based on the type map.
   * @private
   */ uninstallPropertySetWrappers_() {
        /* eslint-disable guard-for-in */ for (const tag of $36d10b35d1f69dea$var$getOwnPropertyNames($36d10b35d1f69dea$var$typeMap))for (const property of $36d10b35d1f69dea$var$getOwnPropertyNames($36d10b35d1f69dea$var$typeMap[tag]["properties"])){
            const constr = this.convertTagToConstructor(tag);
            if (constr != null && this.windowObject_[constr]) this.restoreSetter_(this.windowObject_[constr].prototype, property);
        }
    }
    /** Wraps set attribute with an enforcement function. */ wrapSetAttribute_() {
        const that = this;
        this.wrapFunction_(this.windowObject_.Element.prototype, "setAttribute", /**
         * @this {TrustedTypesEnforcer}
         * @param {function(!Function, ...*)} originalFn
         * @return {*}
         */ function(originalFn, ...args) {
            return that.setAttributeWrapper_.bind(that, this, originalFn).apply(that, args);
        });
        this.wrapFunction_(this.windowObject_.Element.prototype, "setAttributeNS", /**
         * @this {TrustedTypesEnforcer}
         * @param {function(!Function, ...*)} originalFn
         * @return {*}
         */ function(originalFn, ...args) {
            return that.setAttributeNSWrapper_.bind(that, this, originalFn).apply(that, args);
        });
    }
    /**
   * Enforces type checking for Element.prototype.setAttribute.
   * @param {!Object} context The context for the call to the original function.
   * @param {!Function} originalFn The original setAttribute function.
   * @return {*}
   */ setAttributeWrapper_(context, originalFn, ...args) {
        // Note(slekies): In a normal application constructor should never be null.
        // However, there are no guarantees. If the constructor is null, we cannot
        // determine whether a special type is required. In order to not break the
        // application, we will not do any further type checks and pass the call
        // to setAttribute.
        if (context.constructor !== null && this.instanceOfDomProperty(context, "Element")) {
            const attrName = (args[0] = String(args[0])).toLowerCase();
            const requiredType = $36d10b35d1f69dea$export$c7ee71a83251a964.getAttributeType(context["tagName"], attrName, context["namespaceURI"]);
            if (requiredType && $36d10b35d1f69dea$var$apply($36d10b35d1f69dea$var$hasOwnProperty, $36d10b35d1f69dea$var$STRING_TO_TYPE, [
                requiredType
            ])) return this.enforce_(context, "setAttribute", $36d10b35d1f69dea$var$STRING_TO_TYPE[requiredType], originalFn, 1, args);
        }
        return $36d10b35d1f69dea$var$apply(originalFn, context, args);
    }
    /**
   * Enforces type checking for Element.prototype.setAttributeNS.
   * @param {!Object} context The context for the call to the original function.
   * @param {!Function} originalFn The original setAttributeNS function.
   * @return {*}
   */ setAttributeNSWrapper_(context, originalFn, ...args) {
        // See the note from setAttributeWrapper_ above.
        if (context.constructor !== null && this.instanceOfDomProperty(context, "Element")) {
            const ns = args[0] ? String(args[0]) : null;
            args[0] = ns;
            const attrName = (args[1] = String(args[1])).toLowerCase();
            const requiredType = $36d10b35d1f69dea$export$c7ee71a83251a964.getAttributeType(context["tagName"], attrName, context["namespaceURI"], ns);
            if (requiredType && $36d10b35d1f69dea$var$apply($36d10b35d1f69dea$var$hasOwnProperty, $36d10b35d1f69dea$var$STRING_TO_TYPE, [
                requiredType
            ])) return this.enforce_(context, "setAttributeNS", $36d10b35d1f69dea$var$STRING_TO_TYPE[requiredType], originalFn, 2, args);
        }
        return $36d10b35d1f69dea$var$apply(originalFn, context, args);
    }
    /**
   * Wrapper for DOM mutator functions that enforces type checks if the context
   * (or, optionally, its parent node) is a script node.
   * For each argument, it will make sure that text nodes pass through a
   * default policy, or generate a violation. To skip that check, pass
   * TrustedScript objects instead.
   * @param {!Element|!Node} context The context for the call to the original
   * function.
   * @param {boolean} checkParent Check parent of context instead.
   * @param {!Function} originalFn The original mutator function.
   * @return {*}
   */ enforceTypeInScriptNodes_(context, checkParent, originalFn, ...args) {
        const objToCheck = checkParent ? context.parentNode : context;
        if (this.instanceOfDomProperty(objToCheck, "HTMLScriptElement") && args.length > 0) for(let argNumber = 0; argNumber < args.length; argNumber++){
            let arg = args[argNumber];
            if (this.instanceOfDomProperty(arg, "Node") && arg.nodeType !== this.windowObject_.Node.TEXT_NODE) continue; // Type is not interesting
            if (this.instanceOfDomProperty(arg, "Node") && arg.nodeType == this.windowObject_.Node.TEXT_NODE) arg = arg.textContent;
            else if ($36d10b35d1f69dea$export$c7ee71a83251a964.isScript(arg)) {
                // TODO(koto): Consider removing this branch, as it's hard to spec.
                // Convert to text node and go on.
                args[argNumber] = this.windowObject_.document.createTextNode("" + arg);
                continue;
            }
            // Try to run a default policy on argsthe argument
            const fallbackValue = this.maybeCallDefaultPolicy_("TrustedScript", "" + arg, "script.text");
            if (fallbackValue === null || fallbackValue === undefined) this.processViolation_(context, originalFn.name, $36d10b35d1f69dea$export$c7ee71a83251a964.TrustedScript, arg);
            else arg = fallbackValue;
            args[argNumber] = this.windowObject_.document.createTextNode("" + arg);
        }
        return $36d10b35d1f69dea$var$apply(originalFn, context, args);
    }
    /**
   * Wrapper for Element.insertAdjacentText that enforces type checks for
   * inserting text into a script node.
   * @param {!Object} context The context for the call to the original function.
   * @param {!Function} originalFn The original insertAdjacentText function.
   */ insertAdjacentTextWrapper_(context, originalFn, ...args) {
        const riskyPositions = [
            "beforebegin",
            "afterend"
        ];
        if (this.instanceOfDomProperty(context, "Element") && this.instanceOfDomProperty(context["parentElement"], "HTMLScriptElement") && args.length > 1 && riskyPositions.includes(args[0]) && !$36d10b35d1f69dea$export$c7ee71a83251a964.isScript(args[1])) {
            // Run a default policy on args[1]
            args[1] = "" + args[1];
            const fallbackValue = this.maybeCallDefaultPolicy_("TrustedScript", args[1], "script.text");
            if (fallbackValue === null || fallbackValue === undefined) this.processViolation_(context, "insertAdjacentText", $36d10b35d1f69dea$export$c7ee71a83251a964.TrustedScript, args[1]);
            else args[1] = fallbackValue;
            const textNode = this.windowObject_.document.createTextNode("" + args[1]);
            const insertBefore = /** @type function(this: Node) */ this.originalSetters_[this.getKey_(this.windowObject_.Node.prototype, "insertBefore")];
            switch(args[0]){
                case riskyPositions[0]:
                    $36d10b35d1f69dea$var$apply(insertBefore, context["parentElement"], [
                        textNode,
                        context
                    ]);
                    break;
                case riskyPositions[1]:
                    $36d10b35d1f69dea$var$apply(insertBefore, context["parentElement"], [
                        textNode,
                        context["nextSibling"]
                    ]);
                    break;
            }
            return;
        }
        $36d10b35d1f69dea$var$apply(originalFn, context, args);
    }
    /**
   * Wraps a setter with the enforcement wrapper.
   * @param {!Object} object The object of the to-be-wrapped property.
   * @param {string} name The name of the property.
   * @param {!Function} type The type to enforce.
   * @param {number} argNumber Number of the argument to enforce the type of.
   * @private
   */ wrapWithEnforceFunction_(object, name, type, argNumber) {
        const that = this;
        this.wrapFunction_(object, name, /**
         * @this {TrustedTypesEnforcer}
         * @param {function(!Function, ...*)} originalFn
         * @return {*}
         */ function(originalFn, ...args) {
            return that.enforce_.call(that, this, name, type, originalFn, argNumber, args);
        });
    }
    /**
   * Wraps an existing function with a given function body and stores the
   * original function.
   * @param {!Object} object The object of the to-be-wrapped property.
   * @param {string} name The name of the property.
   * @param {function(!Function, ...*)} functionBody The wrapper function.
   */ wrapFunction_(object, name, functionBody) {
        const descriptor = $36d10b35d1f69dea$var$getOwnPropertyDescriptor(object, name);
        const originalFn = /** @type function(*):* */ descriptor ? descriptor.value : null;
        if (!(originalFn instanceof Function)) throw new TypeError("Property " + name + " on object" + object + " is not a function");
        const key = this.getKey_(object, name);
        if (this.originalSetters_[key]) throw new Error(`TrustedTypesEnforcer: Double installation detected: ${key} ${name}`);
        $36d10b35d1f69dea$var$installFunction(object, name, /**
         * @this {TrustedTypesEnforcer}
         * @return {*}
         */ function(...args) {
            return functionBody.bind(this, originalFn).apply(this, args);
        });
        this.originalSetters_[key] = originalFn;
    }
    /**
   * Wraps a setter with the enforcement wrapper.
   * @param {!Object} object The object of the to-be-wrapped property.
   * @param {string} name The name of the property.
   * @param {!Function} type The type to enforce.
   * @param {!Object=} descriptorObject If present, will reuse the
   *   setter/getter from this one, instead of object. Used for redefining
   *   setters in subclasses.
   * @private
   */ wrapSetter_(object, name, type, descriptorObject) {
        if (descriptorObject && !$36d10b35d1f69dea$var$isPrototypeOf.call(descriptorObject, object)) throw new Error("Invalid prototype chain");
        let useObject = descriptorObject || object;
        let descriptor;
        let originalSetter;
        const stopAt = $36d10b35d1f69dea$var$getPrototypeOf(this.windowObject_.Node.prototype);
        do {
            descriptor = $36d10b35d1f69dea$var$getOwnPropertyDescriptor(useObject, name);
            originalSetter = /** @type {function(*):*} */ descriptor ? descriptor.set : null;
            if (!originalSetter) useObject = $36d10b35d1f69dea$var$getPrototypeOf(useObject) || stopAt;
        }while (!(originalSetter || useObject === stopAt || !useObject));
        // if there is no setter warn and return
        // (some setters might not be available in certain environments, e.g. node)
        if (!(originalSetter instanceof Function)) {
            if (this.config_.isLoggingEnabled) // eslint-disable-next-line no-console
            console.warn("No setter for property " + name + " on object" + object);
            return;
        }
        const key = this.getKey_(object, name);
        if (this.originalSetters_[key]) throw new Error(`TrustedTypesEnforcer: Double installation detected: ${key} ${name}`);
        const that = this;
        /**
     * @this {TrustedTypesEnforcer}
     * @param {*} value
     */ const enforcingSetter = function(value) {
            that.enforce_.call(that, this, name, type, originalSetter, 0, [
                value
            ]);
        };
        if (useObject === object) $36d10b35d1f69dea$var$installSetter(object, name, enforcingSetter);
        else // Since we're creating a new setter in subclass, we also need to
        // overwrite the getter.
        $36d10b35d1f69dea$var$installSetterAndGetter(object, name, enforcingSetter, descriptor.get);
        this.originalSetters_[key] = originalSetter;
    }
    /**
   * Restores the original setter for the property, as encountered during
   * install().
   * @param {!Object} object The object of the to-be-wrapped property.
   * @param {string} name The name of the property.
   * @param {!Object=} descriptorObject If present, will restore the original
   *   setter/getter from this one, instead of object.
   * @private
   */ restoreSetter_(object, name, descriptorObject) {
        if (descriptorObject && !$36d10b35d1f69dea$var$isPrototypeOf.call(descriptorObject, object)) throw new Error("Invalid prototype chain");
        let useObject = descriptorObject || object;
        let descriptor;
        let originalSetter;
        const stopAt = $36d10b35d1f69dea$var$getPrototypeOf(this.windowObject_.Node.prototype);
        do {
            descriptor = $36d10b35d1f69dea$var$getOwnPropertyDescriptor(useObject, name);
            originalSetter = /** @type {function(*):*} */ descriptor ? descriptor.set : null;
            if (!originalSetter) useObject = $36d10b35d1f69dea$var$getPrototypeOf(useObject) || stopAt;
        }while (!(originalSetter || useObject === stopAt || !useObject));
        // if there is no setter warn and return
        // (some setters might not be available in certain environments, e.g. node)
        if (!(originalSetter instanceof Function)) {
            if (this.config_.isLoggingEnabled) // eslint-disable-next-line no-console
            console.warn("No setter for property " + name + " on object" + object);
            return;
        }
        const key = this.getKey_(object, name);
        if (!this.originalSetters_[key]) throw new Error(// eslint-disable-next-line max-len
        `TrustedTypesEnforcer: Cannot restore (double uninstallation?): ${key} ${name}`);
        if (descriptorObject) // We have to also overwrite a getter.
        $36d10b35d1f69dea$var$installSetterAndGetter(object, name, this.originalSetters_[key], $36d10b35d1f69dea$var$getOwnPropertyDescriptor(descriptorObject, name).get);
        else $36d10b35d1f69dea$var$installSetter(object, name, this.originalSetters_[key]);
        delete this.originalSetters_[key];
    }
    /**
   * Restores the original method of an object, as encountered during install().
   * @param {!Object} object The object of the to-be-wrapped property.
   * @param {string} name The name of the property.
   * @private
   */ restoreFunction_(object, name) {
        const key = this.getKey_(object, name);
        if (!this.originalSetters_[key]) throw new Error(// eslint-disable-next-line max-len
        `TrustedTypesEnforcer: Cannot restore (double uninstallation?): ${key} ${name}`);
        $36d10b35d1f69dea$var$installFunction(object, name, this.originalSetters_[key]);
        delete this.originalSetters_[key];
    }
    /**
   * Returns the key name for caching original setters.
   * @param {!Object} object The object of the to-be-wrapped property.
   * @param {string} name The name of the property.
   * @return {string} Key name.
   * @private
   */ getKey_(object, name) {
        // TODO(msamuel): Can we use Object.prototype.toString.call(object)
        // to get an unspoofable string here?
        // TODO(msamuel): fail on '-' in object.constructor.name?
        // No Function.name in IE 11
        const ctrName = "" + (object.constructor.name ? object.constructor.name : object.constructor);
        return ctrName + "-" + name;
    }
    /**
   * Calls a default policy.
   * @param {string} typeName Type name to attempt to produce from a value.
   * @param {*} value The value to pass to a default policy
   * @param {string} sink The sink name that the default policy will be called
   *   with.
   * @throws {Error} If the default policy throws, or not exist.
   * @return {Function?} The trusted value or null, if the input value shoudl
   *   be rejected.
   */ maybeCallDefaultPolicy_(typeName, value, sink = "") {
        // Apply a fallback policy, if it exists.
        const fallbackPolicy = $36d10b35d1f69dea$export$c7ee71a83251a964["defaultPolicy"];
        if (!fallbackPolicy) return null;
        if (!$36d10b35d1f69dea$var$TYPE_CHECKER_MAP.hasOwnProperty(typeName)) return null;
        return fallbackPolicy[$36d10b35d1f69dea$var$TYPE_PRODUCER_MAP[typeName]](value, "" + sink);
    }
    /**
   * Logs and enforces TrustedTypes depending on the given configuration.
   * @template T
   * @param {!Object} context The object that the setter is called for.
   * @param {string} propertyName The name of the property.
   * @param {!Function} typeToEnforce The type to enforce.
   * @param {function(?):T} originalSetter Original setter.
   * @param {number} argNumber Number of argument to enforce the type of.
   * @param {Array} args Arguments.
   * @return {T}
   * @private
   */ enforce_(context, propertyName, typeToEnforce, originalSetter, argNumber, args) {
        const value = args[argNumber];
        const typeName = "" + typeToEnforce.name;
        // If typed value is given, pass through.
        if ($36d10b35d1f69dea$var$TYPE_CHECKER_MAP.hasOwnProperty(typeName) && $36d10b35d1f69dea$var$TYPE_CHECKER_MAP[typeName](value)) {
            if ($36d10b35d1f69dea$var$stringifyForRangeHack && propertyName == "createContextualFragment") // IE 11 hack, somehow the value is not stringified implicitly.
            args[argNumber] = args[argNumber].toString();
            return $36d10b35d1f69dea$var$apply(originalSetter, context, args);
        }
        if (typeToEnforce === $36d10b35d1f69dea$export$c7ee71a83251a964.TrustedScript) {
            const isInlineEventHandler = propertyName == "setAttribute" || propertyName === "setAttributeNS" || $36d10b35d1f69dea$var$apply($36d10b35d1f69dea$var$slice, propertyName, [
                0,
                2
            ]) === "on";
            // If a function (instead of string) is passed to inline event attribute,
            // or set(Timeout|Interval), pass through.
            const propertyAcceptsFunctions = propertyName === "setInterval" || propertyName === "setTimeout" || isInlineEventHandler;
            if (propertyAcceptsFunctions && typeof value === "function" || isInlineEventHandler && value === null) return $36d10b35d1f69dea$var$apply(originalSetter, context, args);
        }
        // Apply a fallback policy, if it exists.
        args[argNumber] = "" + value;
        const objName = this.instanceOfDomProperty(context, "Element") ? context["localName"] : this.getConstructorName_(context ? context.constructor : window.constructor);
        const fallbackValue = this.maybeCallDefaultPolicy_(typeName, value, objName + "." + propertyName);
        if (fallbackValue === null || fallbackValue === undefined) // This will throw a TypeError if enforcement is enabled.
        this.processViolation_(context, propertyName, typeToEnforce, value);
        else // Use the value modified by the default policy.
        args[argNumber] = fallbackValue;
        return $36d10b35d1f69dea$var$apply(originalSetter, context, args);
    }
    /**
   * Report a TT violation.
   * @param {!Object} context The object that the setter is called for.
   * @param {string} propertyName The name of the property.
   * @param {!Function} typeToEnforce The type to enforce.
   * @param {string} value The value that was violated the restrictions.
   * @throws {TypeError} if the enforcement is enabled.
   */ processViolation_(context, propertyName, typeToEnforce, value) {
        const contextName = this.getConstructorName_(context.constructor) || "" + context;
        const message = `Failed to set ${propertyName} on ${contextName}: ` + `This property requires ${typeToEnforce.name}.`;
        if (this.config_.isLoggingEnabled) // eslint-disable-next-line no-console
        console.warn(message, propertyName, context, typeToEnforce, value);
        // https://developer.mozilla.org/en-US/docs/Web/API/SecurityPolicyViolationEvent
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1432523
        const SecurityPolicyViolationEvent_ = this.windowObject_["SecurityPolicyViolationEvent"] || null;
        // Unconditionally dispatch an event.
        if (typeof SecurityPolicyViolationEvent_ === "function") {
            let blockedURI = "";
            if (typeToEnforce === $36d10b35d1f69dea$export$c7ee71a83251a964.TrustedScriptURL) {
                blockedURI = $36d10b35d1f69dea$var$parseUrl_(value, this.windowObject_) || "";
                if (blockedURI) blockedURI = blockedURI.href;
            }
            const valueSlice = $36d10b35d1f69dea$var$apply($36d10b35d1f69dea$var$slice, "" + value, [
                0,
                40
            ]);
            const event = new SecurityPolicyViolationEvent_("securitypolicyviolation", {
                "bubbles": true,
                "blockedURI": blockedURI,
                "disposition": this.config_.isEnforcementEnabled ? "enforce" : "report",
                "documentURI": this.windowObject_.document.location.href,
                "effectiveDirective": $36d10b35d1f69dea$var$ENFORCEMENT_DIRECTIVE_NAME,
                "originalPolicy": this.config_.cspString,
                "statusCode": 0,
                "violatedDirective": $36d10b35d1f69dea$var$ENFORCEMENT_DIRECTIVE_NAME,
                "sample": `${contextName}.${propertyName} ${valueSlice}`
            });
            if (this.instanceOfDomProperty(context, "Node") && context["isConnected"]) context["dispatchEvent"](event);
            else this.windowObject_.document.dispatchEvent(event);
        }
        if (this.config_.isEnforcementEnabled) throw new TypeError(message);
    }
}

});

parcelRegister("kCQjJ", function(module, exports) {
/*! @license DOMPurify 2.4.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.7/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== "undefined" && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === "string") {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === "function") return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn("fallback value for", element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "select",
        "shadow",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]); // SVG
    var svg$1 = freeze([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]);
    var svgFilters = freeze([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]); // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "fedropshadow",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]);
    var mathMl$1 = freeze([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover"
    ]); // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]);
    var text = freeze([
        "#text"
    ]);
    var html = freeze([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "pattern",
        "placeholder",
        "playsinline",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "xmlns",
        "slot"
    ]);
    var svg = freeze([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "targetx",
        "targety",
        "transform",
        "transform-origin",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]);
    var mathMl = freeze([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnsalign",
        "columnlines",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lspace",
        "lquote",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]);
    var xml = freeze([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]);
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var getGlobal = function getGlobal() {
        return typeof window === "undefined" ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
         // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = "data-tt-policy-suffix";
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = "dompurify" + (suffix ? "#" + suffix : "");
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = "2.4.7";
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, "cloneNode");
        var getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
        var getChildNodes = lookupGetter(ElementPrototype, "childNodes");
        var getParentNode = lookupGetter(ElementPrototype, "parentNode"); // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === "function") {
            var template = document.createElement("template");
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML("") : "";
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]);
        var MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        var SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            "application/xhtml+xml",
            "text/html"
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = "text/html";
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement("form");
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== "object") cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = "ALLOWED_TAGS" in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = "ALLOWED_ATTR" in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = "ALLOWED_NAMESPACES" in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = "ADD_URI_SAFE_ATTR" in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = "ADD_DATA_URI_TAGS" in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = "FORBID_CONTENTS" in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = "FORBID_TAGS" in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = "FORBID_ATTR" in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = "USE_PROFILES" in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                "html",
                "head",
                "body"
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    "tbody"
                ]);
                delete FORBID_TAGS.tbody;
            } // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            "foreignobject",
            "desc",
            "title",
            "annotation-xml"
        ]); // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            "title",
            "style",
            "font",
            "a",
            "script"
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: "template"
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
                 // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                 // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
                 // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
                 // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                 // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            } // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
             // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes
            if (name === "is" && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, "");
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, "template", null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {}
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== "string" || typeof elm.textContent !== "string" || typeof elm.removeChild !== "function" || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== "function" || typeof elm.setAttribute !== "function" || typeof elm.namespaceURI !== "string" || typeof elm.insertBefore !== "function" || typeof elm.hasChildNodes !== "function");
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === "object" ? object instanceof Node : object && _typeof(object) === "object" && typeof object.nodeType === "number" && typeof object.nodeName === "string";
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook("beforeSanitizeElements", currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook("uponSanitizeElement", currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === "select" && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i)parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, " ");
                content = stringReplace(content, ERB_EXPR$1, " ");
                content = stringReplace(content, TMPLIT_EXPR$1, " ");
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeElements", currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) ;
            else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName.indexOf("-") > 0;
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook("beforeSanitizeAttributes", currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: "",
                attrValue: "",
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === "value" ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook("uponSanitizeAttribute", currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, " ");
                    value = stringReplace(value, ERB_EXPR$1, " ");
                    value = stringReplace(value, TMPLIT_EXPR$1, " ");
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name")) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === "object" && typeof trustedTypes.getAttributeType === "function") {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case "TrustedHTML":
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case "TrustedScriptURL":
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeAttributes", currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook("beforeSanitizeShadowDOM", fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook("uponSanitizeShadowNode", shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeShadowDOM", fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = "<!-->";
            /* Stringify, in case dirty is an object */ if (typeof dirty !== "string" && !_isNode(dirty)) {
                if (typeof dirty.toString === "function") {
                    dirty = dirty.toString();
                    if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
                } else throw typeErrorCreate("toString is not a function");
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === "object" || typeof window1.toStaticHTML === "function") {
                    if (typeof dirty === "string") return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === "string") IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument("<!---->");
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === "BODY") /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === "HTML") body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, " ");
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, " ");
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, " ");
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});




var $35ah2 = parcelRequire("35ah2");

var $2kjdU = parcelRequire("2kjdU");
const $cb2fb967c6d16efe$var$cookieConsentDivData = (0, (/*@__PURE__*/$parcel$interopDefault($2kjdU))).GUI.VWCookieConsentDiv;
const $cb2fb967c6d16efe$var$cookieConsentButtonData = $cb2fb967c6d16efe$var$cookieConsentDivData.WebAgentCookieConsentButton;
class $cb2fb967c6d16efe$export$f2aa1bfe3f422255 {
    div;
    label;
    consentButton;
    packed;
    constructor(){
        this.div = $cb2fb967c6d16efe$export$f2aa1bfe3f422255.createDiv($cb2fb967c6d16efe$var$cookieConsentDivData.ID, $cb2fb967c6d16efe$var$cookieConsentDivData.ClassList);
        this.label = $cb2fb967c6d16efe$export$f2aa1bfe3f422255.createLabel($cb2fb967c6d16efe$var$cookieConsentDivData.WebAgentCookieConsentLabel.ID, $cb2fb967c6d16efe$var$cookieConsentDivData.ID, $cb2fb967c6d16efe$var$cookieConsentDivData.WebAgentCookieConsentLabel.ClassList, $cb2fb967c6d16efe$var$cookieConsentDivData.WebAgentCookieConsentLabel.Text);
        this.consentButton = $cb2fb967c6d16efe$export$f2aa1bfe3f422255.createButton($cb2fb967c6d16efe$var$cookieConsentButtonData.ID, $cb2fb967c6d16efe$var$cookieConsentButtonData.ClassList, $cb2fb967c6d16efe$var$cookieConsentButtonData.Text, $cb2fb967c6d16efe$var$cookieConsentButtonData.Title);
        this.consentButton.addEventListener("click", ()=>{
            document.cookie = "cookie_consent=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/; secure; samesite=strict";
            location.reload();
        });
        this.packed = false;
    }
    static createDiv(id, classList) {
        const div = document.createElement("div");
        div.id = id;
        div.classList.add(...classList);
        div.hidden = true;
        return div;
    }
    static createLabel(id, forID, classList, text) {
        const label = document.createElement("label");
        label.id = id;
        if (forID) label.htmlFor = forID;
        label.classList.add(...classList);
        label.textContent = text;
        return label;
    }
    static createButton(id, classList, text, title) {
        const button = document.createElement("button");
        button.id = id;
        button.classList.add(...classList);
        button.textContent = text;
        button.title = title;
        return button;
    }
    getDiv() {
        (0, $35ah2.VWValidator).validateExistence(this.div, "The cookie consent div is null or undefined.");
        if (!this.packed) this.pack();
        return this.div;
    }
    pack() {
        if (this.packed) console.log("The cookie consent div is already packed.");
        else if (!(0, $35ah2.VWValidator).allArgumentsExist(this.div)) throw new Error("Cannot pack: the cookie consent div is null or undefined.");
        else if (!(0, $35ah2.VWValidator).allArgumentsExist(this.label, this.consentButton)) throw new Error("Cannot pack: one or more of its components are null or undefined.");
        else if (!this.div.hidden) throw new Error("Cannot pack: the cookie consent div is not hidden (it must be before packing it).");
        else {
            this.div.appendChild(this.label);
            this.div.appendChild(this.consentButton);
            this.packed = true;
        }
    }
    unpack() {
        if (!this.packed) console.log("The cookie consent div is already unpacked.");
        else if (!(0, $35ah2.VWValidator).allArgumentsExist(this.div)) throw new Error("Cannot unpack: the cookie consent div is null or undefined.");
        else if (!this.div.hidden) throw new Error("Cannot unpack: the cookie consent div is not hidden (it must be before unpacking it).");
        else {
            $cb2fb967c6d16efe$export$f2aa1bfe3f422255.removeChildrenFromDiv(this.div);
            this.packed = false;
        }
    }
    isPacked() {
        return this.packed;
    }
    hide() {
        if (!(0, $35ah2.VWValidator).allArgumentsExist(this.div)) throw new Error("Cannot hide: the cookie consent div is null or undefined.");
        else if (this.div.hidden) console.log("The cookie consent div is already hidden.");
        else if (!this.packed) throw new Error("Cannot hide: the cookie consent div is not packed.");
        else this.div.hidden = true;
    }
    show() {
        if (!(0, $35ah2.VWValidator).allArgumentsExist(this.div)) throw new Error("Cannot show: the cookie consent div is null or undefined.");
        else if (!this.div.hidden) console.log("The cookie consent div is already shown.");
        else if (!this.packed) throw new Error("Cannot show: the cookie consent div is not packed.");
        else this.div.hidden = false;
    }
    isHidden() {
        return this.div.hidden;
    }
    static removeChildrenFromDiv(div) {
        while(div.firstChild)div.removeChild(div.firstChild);
    }
}



var $ksOKS = parcelRequire("ksOKS");

var $fQzR6 = parcelRequire("fQzR6");
class $2933c4db1859de0b$export$cd1822833f0c37c9 {
    constructor(){}
    static main() {
        document.body.hidden = true;
        (0, $fQzR6.Main).setNonce();
        (0, $fQzR6.Main).setTitle();
        (0, $fQzR6.Main).loadCharset();
        (0, $fQzR6.Main).loadStyles(); // To load the main style of the page, and the themes.
        $2933c4db1859de0b$export$cd1822833f0c37c9.loadMainDiv().then(()=>{
            (0, $fQzR6.Main).initErrorDiv();
            (0, $fQzR6.Main).createToggleThemeDiv();
            (0, $fQzR6.Main).disableFurtherScriptsLoading();
            (0, $ksOKS.VWThemeUtils).adjustComponentsToTheme(); // This call will query the browser local storage.
        }, (error)=>{
            console.error(error);
        });
        (0, $ksOKS.VWThemeUtils).adjustComponentsToTheme(); // This call will query the browser local storage.
        // This is to prevent the content from being displayed before the styles are loaded and applied.
        window.addEventListener("load", ()=>{
            document.body.hidden = false;
        });
    }
    static async loadMainDiv() {
        const cookieConsentDiv = new (0, $cb2fb967c6d16efe$export$f2aa1bfe3f422255)();
        cookieConsentDiv.pack();
        cookieConsentDiv.show();
        document.body.appendChild(cookieConsentDiv.getDiv());
    }
}


window.addEventListener("DOMContentLoaded", ()=>(0, $2933c4db1859de0b$export$cd1822833f0c37c9).main());

})();
//# sourceMappingURL=cookie_consent.js.map
